import { d, g, i, f, h, j as j$1, a, b, e } from './chunk-PVUCCLP3.esm.js';
export { f as capitalize, h as convertRGBToRGBA, a as darkTheme, e as getId, d as isNumber, i as isString, b as lightTheme, j as pickChild, g as shortenName, c as tonightpassTheme } from './chunk-PVUCCLP3.esm.js';
import X, { css, createGlobalStyle, keyframes, useTheme, ThemeProvider, StyleSheetManager } from 'styled-components';
export { ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeContext as StyledThemeContext, ThemeProvider as StyledThemeProvider, ThemeConsumer, createGlobalStyle, css, isStyledComponent, keyframes, useTheme as useStyledTheme, withTheme } from 'styled-components';
import Qn from '@emotion/is-prop-valid';
import { useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from 'next-themes';
import w, { useMemo, forwardRef, useImperativeHandle, Children, useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { isSameMonth, isSameDay, isValid } from 'date-fns';
import { isDateRange, DayPicker } from 'react-day-picker';
import { RiErrorWarningLine, RiExternalLinkLine, RiCloseLine, RiCalendarLine, RiCheckLine, RiSubtractLine, RiArrowDownSLine, RiMoreLine, RiEyeLine, RiEyeCloseLine, RiCheckboxCircleLine, RiAlarmWarningLine, RiInformationLine } from 'react-icons/ri';
import { Controller } from 'react-hook-form';

var jt={family:{primary:"Figtree, -apple-system, sans-serif",monospace:"Fira Code, monospace"},weight:{thin:100,extraLight:200,light:300,regular:400,medium:500,semiBold:600,bold:700,extraBold:800,black:900},size:{extraTitle:"48px",title:"32px",large:"24px",medium:"18px",normal:"16px",compact:"14px",small:"13px",tiny:"11px"},breakpoint:{desktop:"1824px",laptop:"1224px",tablet:"1024px",mobile:"768px"},gap:{tiny:"5px",small:"10px",normal:"15px",medium:"20px",large:"30px",extraLarge:"60px"},radius:{square:"8px",round:"99999px"}};var ee="kc",qt="Kitchn";var Yt=e=>({...jt,...e}),Ne={dark:Yt(a),light:Yt(b)},Rn=["name","size","breakpoint","gap","radius"],Xt=(e,t="")=>{let o={};for(let r in e){let n=e[r];typeof n=="object"?o[r]=Xt(n,`${t}-${r}`):o[r]=`var(--${t?`${t}`:""}-${r}, ${n})`,Rn.includes(r)&&(o[r]=n);}return o},Ye=(e,t="")=>{let o="";for(let r in e){let n=e[r];typeof n=="object"?o+=Ye(n,`${t}-${r}`):o+=`--${t}-${r}: ${n};
`;}return o},Jt=e=>{let t={};for(let o in e)t[o]=Xt(e[o],ee);return t};var yt=w.createContext({theme:Ne.dark,setTheme:e=>{},setThemeStyle:e=>{},resolvedTheme:"system",systemTheme:"system",forcedTheme:void 0,themes:Ne}),Zt=({children:e,themes:t,...o})=>{let r=useTheme$1(),[n,i]=w.useState(t[r.resolvedTheme]||t.dark);return w.useEffect(()=>{i(t[r.resolvedTheme]||t.dark);},[r.resolvedTheme,i]),w.createElement(yt.Provider,{value:{...r,theme:n,setTheme:r.setTheme,setThemeStyle:i,resolvedTheme:r.resolvedTheme,systemTheme:r.systemTheme,forcedTheme:r.forcedTheme,storedTheme:r.theme,themes:t},...o},w.createElement(ThemeProvider,{theme:n},e))};var $e={padding:"12px 16px",margin:"8px 0",width:"420px",maxWidth:"90vw",maxHeight:"75px",placement:"bottomRight"},Hn={toasts:[],toastLayout:$e,updateToastLayout:e=>e,updateToasts:e=>e,lastUpdateToastId:null,updateLastToastId:()=>null},Pt=w.createContext(Hn),Xe=()=>w.useContext(Pt);var eo=css`
  ${({theme:e,background:t,bg:o,backgroundColor:r,bgc:n,backgroundAccent:i,bga:s})=>(t||o||r||n||i||s)&&`background: ${e.colors.layout[t||o]||e.colors.layout[r||n]||e.colors.accent[i||s]||t||o};`}
`;var to=(e,t)=>e.radius[t]||j(t),oo=css`
  ${({theme:e,borderRadius:t,br:o})=>t!==void 0||o!==void 0?`border-radius: ${to(e,t||o)};`:""}

  ${e=>[{key:"border-width",value:e.borderWidth||e.bw||(e.borderColor||e.bc||e.borderTopColor||e.borderBottomColor||e.borderLeftColor||e.borderRightColor||e.btc||e.bbc||e.blc||e.brc||e.borderStyle||e.bs?"1px":void 0)},{key:"border-color",value:e.borderColor||e.bc||(e.borderStyle||e.bs||e.borderWidth||e.bw||e.borderTopWidth||e.borderBottomWidth||e.borderLeftWidth||e.borderRightWidth||e.btw||e.bbw||e.blw||e.brw?e.theme.colors.layout.dark:void 0)},{key:"border-style",value:e.borderStyle||e.bs||(e.borderWidth||e.bw||e.borderTopWidth||e.borderBottomWidth||e.borderLeftWidth||e.borderRightWidth||e.btw||e.bbw||e.blw||e.brw||e.borderColor||e.bc||e.borderTopColor||e.borderBottomColor||e.borderLeftColor||e.borderRightColor||e.btc||e.bbc||e.blc||e.brc?"solid":void 0)},{key:"border-left-width",value:e.borderLeftWidth||e.blw},{key:"border-right-width",value:e.borderRightWidth||e.brw},{key:"border-top-width",value:e.borderTopWidth||e.btw},{key:"border-bottom-width",value:e.borderBottomWidth||e.bbw},{key:"border-left-color",value:e.borderLeftColor||e.blc},{key:"border-right-color",value:e.borderRightColor||e.brc},{key:"border-top-color",value:e.borderTopColor||e.btc},{key:"border-bottom-color",value:e.borderBottomColor||e.bbc},{key:"border-top-left-radius",value:e.borderTopLeftRadius||e.btlr},{key:"border-top-right-radius",value:e.borderTopRightRadius||e.btrr},{key:"border-bottom-left-radius",value:e.borderBottomLeftRadius||e.bblr},{key:"border-bottom-right-radius",value:e.borderBottomRightRadius||e.bbrr}].filter(o=>o.value!==void 0).map(o=>`${o.key}: ${o.key.endsWith("color")?e.theme.colors.layout[o.value]||o.value:o.key.endsWith("radius")?to(e.theme,o.value):o.key.endsWith("width")?j(o.value):o.value};`).join(`
`)}
`;var ro=css`
  ${({theme:e,margin:t,m:o})=>t!==void 0||o!==void 0?`margin: ${v(e,t||o)};`:""}
  ${({theme:e,marginLeft:t,ml:o,mx:r})=>t!==void 0||o!==void 0||r!==void 0?`margin-left: ${v(e,t||o||r)};`:""}
  ${({theme:e,marginRight:t,mr:o,mx:r})=>t!==void 0||o!==void 0||r!==void 0?`margin-right: ${v(e,t||o||r)};`:""}
  ${({theme:e,marginTop:t,mt:o,my:r})=>t!==void 0||o!==void 0||r!==void 0?`margin-top: ${v(e,t||o||r)};`:""}
  ${({theme:e,marginBottom:t,mb:o,my:r})=>t!==void 0||o!==void 0||r!==void 0?`margin-bottom: ${v(e,t||o||r)};`:""}
`;var no=css`
  ${({theme:e,padding:t,p:o})=>t!==void 0||o!==void 0?`padding: ${v(e,t||o)};`:""}
  ${({theme:e,paddingLeft:t,pl:o,px:r})=>t!==void 0||o!==void 0||r!==void 0?`padding-left: ${v(e,t||o||r)};`:""}
  ${({theme:e,paddingRight:t,pr:o,px:r})=>t!==void 0||o!==void 0||r!==void 0?`padding-right: ${v(e,t||o||r)};`:""}
  ${({theme:e,paddingTop:t,pt:o,py:r})=>t!==void 0||o!==void 0||r!==void 0?`padding-top: ${v(e,t||o||r)};`:""}
  ${({theme:e,paddingBottom:t,pb:o,py:r})=>t!==void 0||o!==void 0||r!==void 0?`padding-bottom: ${v(e,t||o||r)};`:""}
`;var io=css`
  ${({position:e,pos:t})=>(e??t)!==void 0?`position: ${e??t};`:""}
  ${({zIndex:e,zi:t})=>(e??t)!==void 0?`z-index: ${e??t};`:""}
  ${({theme:e,left:t,l:o})=>(t??o)!==void 0?`left: ${v(e,t??o)};`:""}
  ${({theme:e,right:t,r:o})=>(t??o)!==void 0?`right: ${v(e,t??o)};`:""}
  ${({theme:e,top:t,t:o})=>(t??o)!==void 0?`top: ${v(e,t??o)};`:""}
  ${({theme:e,bottom:t,b:o})=>(t??o)!==void 0?`bottom: ${v(e,t??o)};`:""}
`;var j=e=>d(e)?`${e}px`:e,v=(e,t)=>e.gap[t]||e.breakpoint[t]||j(t),Wn=(e,t)=>e.size[t]||j(t),l=e=>X(e)`
    ${({display:t})=>t!==void 0?`display: ${t};`:""}
    ${({overflow:t})=>t!==void 0?`overflow: ${t};`:""}
    ${({theme:t,font:o})=>o!==void 0?`font-size: ${Wn(t,o)};`:""}
    ${({cursor:t})=>t!==void 0?`cursor: ${t};`:""}
    ${({pointerEvents:t})=>t!==void 0?`pointer-events: ${t};`:""}
    ${ao}
    ${eo}
    ${oo}
    ${ro}
    ${no}
    ${io}
  `;var ao=css`
  ${({theme:e,width:t,w:o})=>t!==void 0||o!==void 0?`width: ${v(e,t||o)};`:""}
  ${({theme:e,height:t,h:o})=>t!==void 0||o!==void 0?`height: ${v(e,t||o)};`:""}
  ${({theme:e,minWidth:t,minW:o})=>t!==void 0||o!==void 0?`min-width: ${v(e,t||o)};`:""}
  ${({theme:e,minHeight:t,minH:o})=>t!==void 0||o!==void 0?`min-height: ${v(e,t||o)};`:""}
  ${({theme:e,maxWidth:t,maxW:o})=>t!==void 0||o!==void 0?`max-width: ${v(e,t||o)};`:""}
  ${({theme:e,maxHeight:t,maxH:o})=>t!==void 0||o!==void 0?`max-height: ${v(e,t||o)};`:""}
`;var xe=e=>{let[t,o]=w.useState(()=>typeof e=="function"?e():e),r=w.useRef(e);return w.useEffect(()=>{r.current=t;},[t]),[t,i=>{let s=typeof i=="function"?i(r.current):i;r.current=s,o(s);},r]};var so=css`
  body {
    font-family: -apple-system, BlinkMacSystemFont, Roboto, "Segoe UI",
      "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif;
    background-color: ${({theme:e})=>e.colors.layout.darkest};
  }

  option {
    background-color: ${({theme:e})=>e.colors.layout.darkest};
  }

  /* scrollbar */

  html,
  body {
    scrollbar-color: ${({theme:e})=>e.colors.layout.dark}
      ${({theme:e})=>e.colors.layout.darkest};
  }

  ::-webkit-scrollbar {
    width: 5px;
    /* for vertical scrollbars */
    height: 5px;
    /* for horizontal scrollbars */
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({theme:e})=>e.colors.layout.dark};
    height: 5px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    height: 30px;
  }

  /* fonts */

  body,
  input,
  button,
  textarea,
  select,
  option {
    font-family: ${({theme:e})=>e.family.primary};
    font-size: ${({theme:e})=>e.size.normal};
    font-weight: ${({theme:e})=>e.weight.regular};
    text-align: left;
    color: ${({theme:e})=>e.colors.text.lightest};
    line-height: 1.25;
  }

  span {
    line-height: 1;
  }

  strong,
  b {
    font-weight: ${e=>e.theme.weight.bold};
  }

  a {
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:hover {
      filter: brightness(0.8);
    }
  }

  pre,
  code {
    font-family: ${({theme:e})=>e.family.monospace};

    span {
      font-family: ${({theme:e})=>e.family.monospace};
    }
  }
`;var lo=css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote:after,
  q::before,
  q::after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;var jn=(e,t,o)=>(o=o.trim(),`
    ${e==="class"?`:root.${o}`:`[${e}="${o}"]`} {
      ${Ye(t[o],ee)}
    }
  `),co=css`
  ${({staticThemes:e,attribute:t})=>`
    :root {
      ${Ye(e.light,ee)}
    }

    ${Object.keys(e).filter(o=>o!=="light").map(o=>jn(t,e,o))}
  `}
`;var Yn=createGlobalStyle`
    ${lo}
    ${co}
    ${so}
`;var po=Yn;var Je=()=>!!(typeof window<"u"&&window.document&&window.document.createElement);var uo=()=>{let[e,t]=w.useState(!1);return w.useEffect(()=>{t(Je());},[]),{isBrowser:e,isServer:!e}};var ho=e=>document.createElement(e),O=(e$1=e(),t)=>{let o=`${ee}-portal-${e$1}`,{isBrowser:r}=uo(),[n,i]=w.useState(r?ho(o):null);return w.useEffect(()=>{let d=(t?t():null)||document.body,u=d.querySelector(o),c=u||ho(o);u||d.appendChild(c),i(c);},[t,o]),n};var bo=X(e=>{let t=O("toast"),[,o,r]=xe(!1),{toasts:n,updateToasts:i,toastLayout:s,lastUpdateToastId:d}=Xe(),u=useMemo(()=>s,[s]),c=useMemo(()=>n.map(f=>w.createElement(yo,{toast:f,layout:u,key:f._internalIdent})),[n,u]),m=f=>{if(o(f),f)return i(h=>h.map(p=>p.visible?(p._timeout&&window.clearTimeout(p._timeout),{...p,timeout:null}):p));i(h=>h.map((p,b)=>p.visible?(p._timeout&&window.clearTimeout(p._timeout),{...p,_timeout:(()=>{let g=window.setTimeout(()=>{p.cancel(),window.clearTimeout(g);},p.delay+b*100);return g})()}):p));};return w.useEffect(()=>{let f=n.findIndex(b=>b._internalIdent===d),h=n[f];!h||h.visible||!r.current||n.find((b,g)=>g<f&&b.visible)||!r.current||m(!1);},[n,d]),w.useEffect(()=>{let f=null,h=window.setInterval(()=>{n.length!==0&&(f=window.setTimeout(()=>{!n.find(b=>b.visible)&&i(()=>[]),f&&clearTimeout(f);},350));},5e3);return ()=>{h&&clearInterval(h),f&&clearTimeout(f);}},[n]),!t||!n||n.length===0?null:createPortal(w.createElement("div",{onMouseEnter:()=>m(!0),onMouseLeave:()=>m(!1),...e},c),t)})`
  position: fixed;
  width: auto;
  max-width: 100%;
  right: ${({theme:e})=>e.gap.normal};
  bottom: ${({theme:e})=>e.gap.normal};
  z-index: 2000;
  transition: all 400ms ease;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;bo.displayName="KitchnToastContainer";var Zn=l(bo),xo=Zn;var Po=({children:e,enableSystem:t=!0,defaultTheme:o=t?"system":"dark",themes:r={},forcedTheme:n,attribute:i="data-theme",dangerouslyDisableNextThemeProvider:s})=>{let d={...Ne,...r},u=w.useMemo(()=>Jt(d),[r]),[c,m]=w.useState(null),[f,h,p]=xe([]),[b,g,x]=xe($e),T=$=>{let K=$(p.current);h(K);},k=$=>{let K=$(x.current);g(K);},R=$=>{m($());},D=w.useMemo(()=>({toasts:f,toastLayout:b,updateToasts:T,lastUpdateToastId:c,updateToastLayout:k,updateLastToastId:R}),[f,b,c]);return w.createElement(ri,{storageKey:`${ee}-theme`,defaultTheme:o,enableSystem:t,themes:Object.keys(u).map($=>$.toString()),forcedTheme:n,dangerouslyDisableNextThemeProvider:s,attribute:i},w.createElement(StyleSheetManager,{shouldForwardProp:oi,enableVendorPrefixes:!0},w.createElement(Zt,{themes:u},w.createElement(po,{staticThemes:d,attribute:i}),w.createElement(Pt.Provider,{value:D},e,w.createElement(xo,null)))))},oi=(e,t)=>typeof t=="string"?Qn(e):!0,ri=({children:e,dangerouslyDisableNextThemeProvider:t,...o})=>t?w.createElement(w.Fragment,null,e):w.createElement(ThemeProvider$1,{...o},e);Po.displayName="KitchnProvider";var sm=l(Po);var To=X(({children:e,...t})=>{let o=t.h1?"h1":t.h2?"h2":t.h3?"h3":t.h4?"h4":t.h5?"h5":t.h6?"h6":t.b?"b":t.i?"i":t.span?"span":t.em?"em":"p";return w.createElement(o,{role:"text",...t},e)})`
  font-size: ${e=>e.size!==void 0?e.theme.size[e.size]||j(e.size):e.theme.size.normal};
  font-weight: ${e=>e.weight?e.theme.weight[e.weight]||e.weight:e.b?e.theme.weight.bold:e.theme.weight.regular};
  color: ${e=>e.theme.colors.accent[e.accent]||e.theme.colors.text[e.color]||e.color||e.theme.colors.text.lightest};
  text-align: ${e=>e.align||"left"};
  text-transform: ${e=>e.transform||"initial"};
  text-decoration: ${e=>e.decoration||"none"};
  line-height: ${e=>e.lineHeight||1.25};
  white-space: ${e=>e.wrap!==void 0?e.wrap?"normal":"nowrap":"normal"};
  font-family: ${e=>e.monospace&&e.theme.family.monospace?"monospace":e.theme.family.primary};
  ${e=>e.truncate&&`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    ${Number(e.truncate)>1?`
      display: -webkit-box;
      -webkit-line-clamp: ${e.truncate};
      -webkit-box-orient: vertical;
      white-space: normal;
    `:""}
  `}

  span {
    line-height: ${e=>e.lineHeight||1};
  }

  em {
    font-style: italic;
  }
`;To.displayName="KitchnText";var Ke=l(To),C=Ke;var ko=X(({size:e=30,src:t,text:o,shape:r,username:n,...i})=>w.createElement("div",{role:"img","aria-label":o||"Avatar",...i},o&&!t&&w.createElement(C,{size:"0.4em"},g(o)),t&&w.createElement(ai,{src:n?`https://tonightpass.com/@${n}.png`:t,shape:r,alt:"Avatar",width:e,height:e,draggable:!1})))`
  width: ${({size:e})=>j(e||30)};
  height: ${({size:e})=>j(e||30)};
  border-radius: ${({shape:e,theme:t})=>e==="square"?t.radius.square:t.radius.round};
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  font-size: ${({size:e})=>j(e||30)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  user-select: none;
  background-color: ${({theme:e})=>e.colors.layout.darker};
  transition: all 0.2s;
  overflow: hidden;
`,ai=X.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${({shape:e,theme:t})=>e==="square"?t.radius.square:t.radius.round};
`;ko.displayName="KitchnAvatar";var si=l(ko),Qe=si;var $o=X(({members:e,size:t,limit:o,...r})=>w.createElement("div",{role:"group","aria-label":"Avatar Group",...r},e.slice(0,o||e.length).map((n,i)=>w.createElement(Qe,{key:i,size:t,...n})),o&&e.length>o&&w.createElement(C,{size:"small"},"+",e.length-o)))`
  display: flex;
  align-items: center;

  ${C} {
    margin-left: ${({theme:e})=>e.gap.tiny};
  }

  ${Qe} {
    margin-left: -10px;

    ${C} {
      margin-left: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }

  &:hover {
    ${Qe} {
      margin-left: 0;
    }
  }
`;$o.displayName="KitchnAvatarGroup";var vm=l($o);var vo=X(({children:e,...t})=>w.createElement("span",{role:"status","aria-live":"polite",...t},e&&i(e)?f(e):e))`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  white-space: nowrap;
  padding: 0 10px;
  font-weight: ${({bold:e,theme:t})=>e?t.weight.bold:t.weight.medium};
  border-radius: 8px;

  padding: ${e=>{switch(e.size){case"small":return "2px 4px";case"large":return "8px 12px";case"normal":default:return "4px 8px"}}};

  font-size: ${e=>{switch(e.size){case"small":return e.theme.size.tiny;case"large":return e.theme.size.normal;case"normal":default:return e.theme.size.small}}};

  color: ${({theme:e,type:t})=>{switch(t){case"danger":case"warning":case"info":case"success":case"secondary":return e.colors.accent.light;case"primary":default:return e.colors.text.lightest}}};

  background-color: ${({theme:e,type:t})=>{switch(t){case"danger":return e.colors.accent.danger;case"warning":return e.colors.accent.warning;case"info":return e.colors.accent.info;case"success":return e.colors.accent.success;case"secondary":return e.colors.layout.light;case"primary":default:return e.colors.layout.dark}}};
`;vo.displayName="KitchnBadge";var Im=l(vo);var zm=keyframes`
  0% {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
`,Hm=keyframes`
  0% {
      opacity: 1;
  }
  to {
      opacity: 0;
  }
`,wo=keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -70%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`,Eo=keyframes`
  0% {
      opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -70%, 0);
  }
`,Bm=keyframes`
  0% {
      transform: translatey(0px);
  }
  50% {
      transform: translatey(-10px);
  }
  100% {
      transform: translatey(0px);
  }
`,Am=keyframes`
  0% {
    background-position: 0% 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0% 0;
  }
`,Nm=keyframes`
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
`,So=keyframes`
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`,Fm=keyframes`
  0% {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
`,Mo=keyframes`
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
`,Lo=keyframes`
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
`;var Io=X(({...e})=>w.createElement("div",{role:"status","aria-label":"Loading",...e},w.createElement("div",{className:"bounce1"}),w.createElement("div",{className:"bounce2"}),w.createElement("div",{className:"bounce3"})))`
  display: flex;
  align-items: center;
  width: ${({size:e})=>e||50}px;
  height: ${({size:e})=>e||50}px;
  text-align: center;

  div {
    width: 25%;
    height: 25%;
    background-color: ${({color:e,theme:t})=>e||t.colors.accent.light};

    border-radius: 100%;
    display: inline-block;
    animation: ${So} 1.4s infinite ease-in-out both;
  }

  .bounce1 {
    animation-delay: -0.32s;
  }

  .bounce2 {
    animation-delay: -0.16s;
  }
`;Io.displayName="KitchnSpinner";var di=l(Io),Ro=di;var Do=X(({as:e="button",children:t,loading:o,size:r,width:n,prefix:i,suffix:s,type:d,htmlType:u,...c})=>{let m=useTheme();return w.createElement(e,{"aria-label":t?void 0:"Button","aria-busy":o?"true":void 0,"aria-disabled":c.disabled?"true":void 0,role:"button",type:u,$type:d,...c},(i||o)&&w.createElement(hi,{hasContent:t!==void 0},o?w.createElement(Ro,{size:r?r==="small"?12:r==="large"?20:16:16,color:m.colors.text.dark}):i),w.createElement(fi,{width:n},t),s&&w.createElement(gi,null,s))})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  outline: none;
  transition: all 0.2s;
  line-height: 1;
  user-select: none;
  font-weight: ${({theme:e})=>e.weight.bold};
  font-family: ${({theme:e})=>e.family.primary};
  cursor: ${e=>e.disabled||e.loading?"not-allowed":"pointer"};
  border-radius: ${({shape:e})=>e==="round"?"99999px":"8px"};
  width: ${({width:e})=>e?d(e)?`${e}px`:e:"auto"};

  padding: ${e=>{switch(e.size){case"small":return "6px 8px";case"large":return "12px 16px";case"normal":default:return "8px 12px"}}};

  color: ${e=>{if(e.loading||e.disabled)return `${e.theme.colors.text.light}`;if(e.variant==="ghost")switch(e.type){case"light":return e.theme.colors.text.lightest;case"dark":return e.theme.colors.text.light;case"info":return e.theme.colors.accent.info;case"success":return e.theme.colors.accent.success;case"warning":return e.theme.colors.accent.warning;case"danger":return e.theme.colors.accent.danger;case"secondary":return e.theme.colors.accent.secondary;case"primary":return e.theme.colors.accent.primary}switch(e.type){case"light":return e.theme.colors.text.darkest;case"dark":return e.theme.colors.text.lightest;default:return e.theme.colors.accent.light}}};

  background: ${e=>{if(e.loading||e.disabled)return `${e.theme.colors.layout.darker}`;if(e.variant==="ghost")return "transparent";switch(e.type){case"dark":return e.theme.colors.layout.darkest;case"light":return e.theme.colors.layout.lightest;case"info":return e.theme.colors.accent.info;case"success":return e.theme.colors.accent.success;case"warning":return e.theme.colors.accent.warning;case"danger":return e.theme.colors.accent.danger;case"secondary":return e.theme.colors.accent.secondary;case"primary":default:return e.theme.colors.accent.primary}}};

  border: ${e=>{if(e.loading||e.disabled)return `1px solid ${e.theme.colors.layout.dark}`;if(e.variant==="ghost")return "1px solid transparent";switch(e.type){case"dark":return `1px solid ${e.theme.colors.layout.dark}`;case"light":return `1px solid ${e.theme.colors.layout.lightest}`;case"info":return `1px solid ${e.theme.colors.accent.info}`;case"success":return `1px solid ${e.theme.colors.accent.success}`;case"warning":return `1px solid ${e.theme.colors.accent.warning}`;case"danger":return `1px solid ${e.theme.colors.accent.danger}`;case"secondary":return `1px solid ${e.theme.colors.accent.secondary}`;case"primary":default:return `1px solid ${e.theme.colors.accent.secondary}`}}};

  font-size: ${e=>{switch(e.size){case"small":return e.theme.size.small;case"large":return e.theme.size.medium;case"normal":default:return e.theme.size.normal}}};

  &:hover {
    ${e=>e.hover?.background&&`background: ${e.hover.background}`};
    ${e=>e.hover?.color&&`color: ${e.hover.background}`};

    background: ${e=>{if(e.variant==="ghost")switch(e.type){case"light":return h(e.theme.colors.layout.lightest,.25);case"dark":return h(e.theme.colors.layout.light,.25);case"info":return h(e.theme.colors.accent.info,.25);case"success":return h(e.theme.colors.accent.success,.25);case"warning":return h(e.theme.colors.accent.warning,.25);case"danger":return h(e.theme.colors.accent.danger,.25);case"secondary":return h(e.theme.colors.accent.secondary,.25);case"primary":return h(e.theme.colors.accent.primary,.25)}return ""}};

    border: ${e=>{if(e.loading||e.disabled)return `1px solid ${e.theme.colors.layout.dark}`;if(e.variant==="ghost")return `1px solid ${h(e.theme.colors.accent.light,.25)}`;switch(e.type){case"dark":return `1px solid ${e.theme.colors.layout.light}`;case"light":case"info":case"success":case"warning":case"danger":case"secondary":return `1px solid ${h(e.theme.colors.accent.light,.25)}`;case"primary":default:return `1px solid ${e.theme.colors.accent.secondary}`}}};

    &:focus {
      filter: brightness(
        ${e=>e.disabled||e.loading?"1":"0.8"}
      );
    }
  }
`,fi=X.span`
  font-weight: ${({theme:e})=>e.weight.semiBold};
  font-size: inherit;
  font-family: inherit;
  color: inherit;

  ${({width:e})=>e&&"text-overflow: ellipsis; overflow: hidden;  white-space: nowrap;"};
`,hi=X.span`
  font-size: inherit;
  color: inherit;
  ${({hasContent:e})=>e&&"margin-right: 7px;"}
`,gi=X.span`
  font-size: inherit;
  margin-left: 7px;
  color: inherit;
`;Do.displayName="KitchnButton";var bi=l(Do),ve=bi;function We(e){let t=i=>typeof window<"u"?window.matchMedia(i).matches:!1,[o,r]=useState(t(e));function n(){r(t(e));}return useEffect(()=>{let i=window.matchMedia(e);return n(),i.addListener?i.addListener(n):i.addEventListener("change",n),()=>{i.removeListener?i.removeListener(n):i.removeEventListener("change",n);}},[e]),o}var we=()=>{let e=useTheme();return {isMobile:We(`(max-width: ${e.breakpoint.mobile})`),isTablet:We(`(max-width: ${e.breakpoint.tablet})`),isLaptop:We(`(max-width: ${e.breakpoint.laptop})`),isDesktop:We(`(max-width: ${e.breakpoint.desktop})`)}};var id=(e=!1)=>{let[t,o]=w.useState(e);return [t,()=>o(n=>!n)]};var ot=e=>{w.useEffect(()=>{let t=o=>e(o);return document.addEventListener("click",t),()=>document.removeEventListener("click",t)},[e]);};var zo=(e,t)=>{let o=w.useRef(t);w.useEffect(()=>{o.current=t;},[t]),w.useEffect(()=>{let r=n=>{let i=e.current;!n||!i||i.contains(n.target)||o.current(n);};return document.addEventListener("click",r),()=>document.removeEventListener("click",r)},[e]);};var Ho={},Ee=(e,t)=>{let o=t?` [${t}]`:" ",r=`[${qt}]${o}: ${e}`;typeof console>"u"||Ho[r]||(Ho[r]=!0,console.warn(r));};var $i={onError:()=>Ee("Failed to copy.","useClipboard")},gd=(e=$i)=>{let t=O("clipboard"),o=(n,i)=>{if(!n||!i)return;let s=window.getSelection();if(!s)return;n.style.whiteSpace="pre",n.textContent=i;let d=window.document.createRange();s.removeAllRanges(),d.selectNode(n),s.addRange(d);try{window.document.execCommand("copy");}catch{e.onError&&e.onError();}s.removeAllRanges(),n&&(n.textContent="");};return {copy:w.useCallback(n=>{o(t,n);},[t])}};var wi={visible:!1},rt=w.createContext(wi);var nt=()=>w.useContext(rt);var Bo=(e,t=()=>{})=>{let o={attributes:!1,childList:!0,subtree:!0};w.useEffect(()=>{if(!e||!e.current)return;let r=!1,n=(...s)=>{r||t(...s);},i=new MutationObserver(n);return i.observe(e.current,o),()=>{r=!0,i.disconnect();}},[e]);};var vt=(a=>(a[a.Unknown=0]="Unknown",a[a.Backspace=8]="Backspace",a[a.Tab=9]="Tab",a[a.Enter=13]="Enter",a[a.Shift=16]="Shift",a[a.Ctrl=17]="Ctrl",a[a.Alt=18]="Alt",a[a.PauseBreak=19]="PauseBreak",a[a.CapsLock=20]="CapsLock",a[a.Escape=27]="Escape",a[a.Space=32]="Space",a[a.PageUp=33]="PageUp",a[a.PageDown=34]="PageDown",a[a.End=35]="End",a[a.Home=36]="Home",a[a.LeftArrow=37]="LeftArrow",a[a.UpArrow=38]="UpArrow",a[a.RightArrow=39]="RightArrow",a[a.DownArrow=40]="DownArrow",a[a.Insert=45]="Insert",a[a.Delete=46]="Delete",a[a.KEY_0=48]="KEY_0",a[a.KEY_1=49]="KEY_1",a[a.KEY_2=50]="KEY_2",a[a.KEY_3=51]="KEY_3",a[a.KEY_4=52]="KEY_4",a[a.KEY_5=53]="KEY_5",a[a.KEY_6=54]="KEY_6",a[a.KEY_7=55]="KEY_7",a[a.KEY_8=56]="KEY_8",a[a.KEY_9=57]="KEY_9",a[a.KEY_A=65]="KEY_A",a[a.KEY_B=66]="KEY_B",a[a.KEY_C=67]="KEY_C",a[a.KEY_D=68]="KEY_D",a[a.KEY_E=69]="KEY_E",a[a.KEY_F=70]="KEY_F",a[a.KEY_G=71]="KEY_G",a[a.KEY_H=72]="KEY_H",a[a.KEY_I=73]="KEY_I",a[a.KEY_J=74]="KEY_J",a[a.KEY_K=75]="KEY_K",a[a.KEY_L=76]="KEY_L",a[a.KEY_M=77]="KEY_M",a[a.KEY_N=78]="KEY_N",a[a.KEY_O=79]="KEY_O",a[a.KEY_P=80]="KEY_P",a[a.KEY_Q=81]="KEY_Q",a[a.KEY_R=82]="KEY_R",a[a.KEY_S=83]="KEY_S",a[a.KEY_T=84]="KEY_T",a[a.KEY_U=85]="KEY_U",a[a.KEY_V=86]="KEY_V",a[a.KEY_W=87]="KEY_W",a[a.KEY_X=88]="KEY_X",a[a.KEY_Y=89]="KEY_Y",a[a.KEY_Z=90]="KEY_Z",a[a.Meta=91]="Meta",a[a.F1=112]="F1",a[a.F2=113]="F2",a[a.F3=114]="F3",a[a.F4=115]="F4",a[a.F5=116]="F5",a[a.F6=117]="F6",a[a.F7=118]="F7",a[a.F8=119]="F8",a[a.F9=120]="F9",a[a.F10=121]="F10",a[a.F11=122]="F11",a[a.F12=123]="F12",a[a.NumLock=144]="NumLock",a[a.ScrollLock=145]="ScrollLock",a[a.Equal=187]="Equal",a[a.Minus=189]="Minus",a[a.Backquote=192]="Backquote",a[a.Backslash=220]="Backslash",a))(vt||{}),Se=(n=>(n[n.CtrlCmd=2048]="CtrlCmd",n[n.Shift=1024]="Shift",n[n.Alt=512]="Alt",n[n.WinCtrl=256]="WinCtrl",n))(Se||{});var Ao=e=>{let t=e.filter(r=>!!Se[r]),o={CtrlCmd:!1,Shift:!1,Alt:!1,WinCtrl:!1};return t.forEach(r=>{let n=Se[r];o[n]=!0;}),o};var wt=()=>Je()?navigator.platform.toUpperCase().indexOf("MAC")>=0:!1;var No=()=>({CtrlCmd:wt()?"metaKey":"ctrlKey",WinCtrl:wt()?"ctrlKey":"metaKey"});var it=(e,t,o={})=>{let r=Array.isArray(t)?t:[t],{disableGlobalEvent:n=!1,capture:i=!1,stopPropagation:s=!1,preventDefault:d=!0,event:u="keydown"}=o,c=Ao(r),m=r.filter(g=>!Se[g]),{CtrlCmd:f,WinCtrl:h}=No(),p=w.useCallback(g=>{if(c.Shift&&!g.shiftKey||c.Alt&&!g.altKey||c.CtrlCmd&&!g[f]||c.WinCtrl&&!g[h])return;let x=m.find(T=>T===g.keyCode);m&&!x||(s&&g.stopPropagation(),d&&g.preventDefault(),e&&e(g));},[c,f,h,m,e,d,s]);w.useEffect(()=>(n||document.addEventListener(u,p),()=>{document.removeEventListener(u,p);}),[n,u,p]);let b=(g,x=!1)=>g!==u?()=>null:x!==i?()=>null:T=>p(T);return {bindings:{onKeyDown:b("keydown"),onKeyDownCapture:b("keydown",!0),onKeyPress:b("keypress"),onKeyPressCapture:b("keypress",!0),onKeyUp:b("keyup"),onKeyUpCapture:b("keyup",!0)}}};var Gd=()=>{let[e,t]=w.useState(!1),o=w.useCallback(()=>t(!0),[]),r=w.useCallback(()=>t(!1),[]);return [e,o,r]};var Ko=e=>{let t=useRef(null);return useEffect(()=>{t.current=e;}),t?t.current:null};var Oo=e=>{if(!e)return {top:0,left:0};let{top:t,left:o}=e.getBoundingClientRect();return {top:t,left:o}};var Me={top:-1e3,left:-1e3,right:-1e3,width:0,height:0,elementTop:-1e3},Wo=(e,t)=>{if(!e)return Me;let o=t?t():null,r=o||document.documentElement,{top:n,left:i}=Oo(o);return {...e,width:e.width||e.right-e.left,height:e.height||e.top-e.bottom,top:e.bottom+r.scrollTop-n,left:e.left+r.scrollLeft-i,elementTop:e.top+r.scrollTop-n}},at=(e,t)=>{if(!e||!e.current)return Me;let o=e.current.getBoundingClientRect();return Wo(o,t)},Ri=(e,t)=>{let o=e?.currentTarget?.getBoundingClientRect();return o?Wo(o,t):Me},_o=e=>e?e.top===Me.top&&e.left===Me.left:!0,st=e=>{let[t,o]=w.useState(e||Me);return {rect:t,setRect:(i,s)=>{o(Ri(i,s));},setRectWithRef:(i,s)=>{o(at(i,s));}}};var lt=(e,t=!0)=>{w.useEffect(()=>{let o=()=>e();return t&&o(),window.addEventListener("resize",o),()=>window.removeEventListener("resize",o)},[]);};var Go=()=>({...w.useContext(yt)});var Vo={delay:2e3,type:"primary"},au=e$1=>{let{updateToasts:t,toasts:o,updateToastLayout:r,updateLastToastId:n}=Xe();w.useEffect(()=>{e$1&&r(()=>e$1?{...$e,...e$1}:$e);},[]);let i=m=>{t(f=>f.map(h=>h._internalIdent!==m?h:{...h,visible:!1})),n(()=>m);};return {toasts:o,setToast:m=>{let f=`toast-${e()}`,h=m.delay||Vo.delay;if(m.id&&o.find(b=>b.id===m.id))throw new Error('Toast: Already have the same key: "ident"');t(p=>{let b={delay:h,text:m.text,visible:!0,type:m.type||Vo.type,id:m.id||f,actions:m.actions||[],_internalIdent:f,_timeout:window.setTimeout(()=>{i(f),b._timeout&&(window.clearTimeout(b._timeout),b._timeout=null);},h),cancel:()=>i(f)};return [...p,b]});},removeAll:()=>{t(m=>m.map(f=>({...f,visible:!1})));},findOneToastByID:m=>o.find(f=>f.id===m),removeOneToastByID:m=>{t(f=>f.map(h=>h.id!==m?h:{...h,visible:!1}));}}};var Iu=e=>(Ee("withBox is deprecated, please use withDecorator instead."),l(e));var Bu=e=>(Ee("withScale is deprecated, please use withDecorator instead."),l(e));var jo=w.forwardRef(({children:e,header:t,section:o,form:r,label:n,...i},s)=>w.createElement(t?"header":o?"section":r?"form":n?"label":"div",{ref:s,role:t?"banner":o?"region":void 0,...i},e));jo.displayName="Container";var qo=X(jo)`
  display: flex;
  flex-direction: ${e=>e.direction&&e.direction[e.direction.length-1]||(e.row?"row":"column")};
  ${e=>e.flex&&`flex: ${e.flex};`}
  justify-content: ${e=>e.justify||"flex-start"};
  align-items: ${e=>e.align||"stretch"};
  ${e=>e.wrap&&`flex-wrap: ${e.wrap};`}

  ${e=>e.gap&&`gap: ${e.theme.gap[e.gap]||`${e.gap}px`};`}
  @media (max-width: ${e=>e.theme.breakpoint.laptop}) {
    ${e=>e.direction&&e.direction[2]&&`flex-direction: ${e.direction[2]};`}
  }

  @media (max-width: ${e=>e.theme.breakpoint.tablet}) {
    ${e=>e.direction&&e.direction[1]&&`flex-direction: ${e.direction[1]};`}
  }

  @media (max-width: ${e=>e.theme.breakpoint.mobile}) {
    ${e=>e.direction&&e.direction[0]&&`flex-direction: ${e.direction[0]};`}
  }
`;qo.displayName="KitchnContainer";var _e=l(qo),y=_e;var Yo=X(({icon:e,size:t,...o})=>{let r=useTheme();return w.createElement(e,{role:"img",size:r.size[t]||t||r.size.normal,height:r.size[t]||t||r.size.normal,width:r.size[t]||t||r.size.normal,...o})})`
  color: ${e=>e.theme.colors.accent[e.accent]||e.theme.colors.text[e.color]||e.color||e.theme.colors.text.lightest};
  vertical-align: ${({align:e})=>{switch(e){case"top":return "text-top";case"middle":return "middle";case"bottom":return "text-bottom";default:return "middle"}}};
  cursor: ${({clickable:e})=>e?"pointer":"default"};
  pointer-events: ${({clickable:e})=>e?"auto":"none"};
`;Yo.displayName="KitchnIcon";var Ki=l(Yo),M=Ki;var Xo=X(({label:e=!0,size:t,error:o,children:r,...n})=>w.createElement("div",{role:"alert","aria-live":"assertive",...n},w.createElement(_i,null,w.createElement(M,{icon:RiErrorWarningLine,accent:"danger",size:t==="small"?15:t==="large"?20:18,align:"bottom"})),w.createElement(Gi,null,w.createElement(Vi,{size:t,accent:"danger"},e&&w.createElement(Ui,null,typeof e=="string"?e:"Error",e?": ":""),w.createElement(ji,null,o?o.message:r),o&&w.createElement(qi,{href:o.link,target:"_blank",rel:"noopener noreferrer"},o.action,w.createElement(Yi,{accent:"danger",icon:RiExternalLinkLine,size:t}))))))`
  display: flex;
  line-height: 1;

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
`,_i=X.div``,Gi=X.div`
  margin-left: 8px;
`,Vi=X(C)`
  font-size: ${e=>{switch(e.size){case"small":return e.theme.size.tiny;case"large":return e.theme.size.normal;case"normal":default:return e.theme.size.small}}};
  word-break: break-word;
`,Ui=X.b`
  font-size: inherit;
  font-weight: ${({theme:e})=>e.weight.semiBold};
  color: ${({theme:e})=>e.colors.accent.danger};
`,ji=X.span`
  font-size: inherit;
  font-family: inherit;
  color: ${({theme:e})=>e.colors.accent.danger};
`,qi=X.a`
  display: inline-flex;
  font-size: inherit;
  color: inherit;
  margin-left: ${({theme:e})=>e.gap.tiny};
  background-image: linear-gradient(currentColor, currentColor);
  background-size: 100% 1px;
  background-position: 0 100%;
  background-repeat: no-repeat;
`,Yi=X(M)`
  margin-left: ${({theme:e})=>e.gap.tiny};
`;Xo.displayName="KitchnError";var Xi=l(Xo),Jo=Xi;var ea=(e,t)=>({...t,target:e,currentTarget:e}),Zo=forwardRef(({size:e="normal",prefix:t,suffix:o,suffixIcon:r,onIconClick:n,clickableIcon:i,disabled:s=!1,prefixContainer:d=!0,suffixContainer:u=!0,prefixStyling:c=!0,suffixStyling:m=!0,clearable:f=!1,value:h,initialValue:p="",readOnly:b=!1,onChange:g,width:x,onClearClick:T,onFocus:k,onBlur:R,error:D,type:$,label:K,htmlType:ge,...L},ae)=>{let H=w.useRef(null),[He,se]=w.useState(p),[be,Ue]=w.useState(!1),[gt,je]=w.useState(!1),Be=w.useMemo(()=>h!==void 0,[h]);useImperativeHandle(ae,()=>H.current);let Ae=K?ta:w.Fragment,I={...L,...Be?{value:He}:{defaultValue:p}},bt=U=>{s||b||(Ue(!0),k&&k(U));},wn=U=>{s||b||(se(U.target.value),g&&g(U));},En=U=>{s||b||(Ue(!1),R&&R(U));},Sn=()=>{s||b||je(!0);},Mn=()=>{s||b||je(!1);},Ln=U=>{if(s||b||(se(""),T&&T(U),!H.current))return;let _t=ea(H.current,U);_t.target.value="",g&&g(_t),H.current.focus();},Wt=U=>{s||n&&n(U);},In=w.useMemo(()=>({clickable:i,onClick:Wt}),[i,Wt]);return w.useEffect(()=>{Be&&se(h);},[Be,h]),w.createElement(Ae,null,K&&w.createElement(la,null,K),w.createElement(oa,{disabled:s,width:x,size:e},t&&d&&w.createElement(na,{size:e,disabled:s,prefixStyling:c,focus:be,error:D,type:$},t),w.createElement(ra,{ref:H,size:e,prefix:t,suffix:o,prefixContainer:d,suffixContainer:u,suffixIcon:r,prefixStyling:c,suffixStyling:m,disabled:s,clearable:f,value:h,onChange:wn,error:D,onFocus:bt,onBlur:En,focus:be,$type:$,type:ge,...I}),f&&h!==void 0&&w.createElement(aa,{size:e,disabled:s,suffix:o,suffixContainer:u,suffixStyling:m,error:D,focus:be,type:$,visible:!!(H.current&&H.current.value!==""),lastItem:!r},w.createElement(M,{icon:RiCloseLine,onMouseEnter:Sn,onMouseLeave:Mn,onClick:Ln,color:gt&&!s&&!b?"lightest":"light",size:e==="small"?16:e==="large"?24:20})),r&&w.createElement(er,{size:e,disabled:s,suffix:o,suffixContainer:u,suffixStyling:m,error:D,focus:be,type:$,lastItem:!0},w.createElement(M,{icon:r,color:!s&&!b?"lightest":"light",size:e==="small"?16:e==="large"?24:20,...In})),o&&u&&w.createElement(ia,{size:e,disabled:s,suffixStyling:m,focus:be,error:D,type:$},o)),D&&w.createElement(sa,{size:e,width:x},D))});Zo.displayName="Input";var ta=X(e=>w.createElement(y,{label:!0,...e}))``,Qo=X(Zo)`
  font: inherit;
  width: 100%;
  min-width: 0;
  display: inline-flex;
  appearance: none;
  line-height: normal;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  -webkit-tap-highlight-color: transparent;
  border-radius: ${({theme:e})=>e.radius.square};
  color: ${({theme:e,error:t,type:o})=>t?e.colors.accent.danger:o?e.colors.accent[o]:e.colors.text.lightest};
  background-color: ${({theme:e,disabled:t})=>t?e.colors.layout.darker:e.colors.layout.darkest};
  ${({disabled:e})=>e&&"cursor: not-allowed;"}

  ::placeholder {
    color: ${({theme:e,error:t,type:o})=>t?h(e.colors.accent.danger,.5):o?h(e.colors.accent[o],.5):e.colors.text.light};
    font-weight: ${({theme:e})=>e.weight.semiBold};
  }
`,oa=X.div`
  display: flex;
  align-items: center;
  width: ${({width:e})=>e?d(e)?`${e}px`:e:"100%"};
  max-width: 100%;
  font-size: ${({size:e,theme:t})=>{switch(e){case"small":return t.size.compact;case"large":return t.size.normal;case"normal":default:return t.size.small}}};
  border-radius: ${({theme:e})=>e.radius.square};
  ${({disabled:e})=>e&&"cursor: not-allowed;"}
`,ra=X.input`
  padding: 0 ${({theme:e})=>e.gap.small};
  height: ${e=>{switch(e.size){case"small":return "30px";case"large":return "50px";case"normal":default:return "40px"}}};
  font-size: inherit;

  border: 1px solid
    ${({theme:e,error:t,focus:o,$type:r})=>t?e.colors.accent.danger:r?e.colors.accent[r]:o?e.colors.layout.lighter:e.colors.layout.dark};

  ${({prefix:e,prefixContainer:t})=>e&&t&&`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `}
  ${({suffix:e,suffixContainer:t,suffixIcon:o,clearable:r,value:n})=>(e&&t||o||r&&n!==void 0)&&`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `}
  ${({prefix:e,prefixContainer:t,prefixStyling:o})=>e&&t&&!o&&"border-left: none;"}
  ${({suffix:e,suffixContainer:t,suffixIcon:o,suffixStyling:r,clearable:n,value:i})=>(e&&t&&!r||o||n&&i!==void 0)&&"border-right: none;"}
`,na=X.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({theme:e})=>e.colors.text.light};
  border: 1px solid
    ${({theme:e,error:t,focus:o,prefixStyling:r,type:n})=>t&&!r?e.colors.accent.danger:n&&!r?e.colors.accent[n]:o&&!r?e.colors.layout.lighter:e.colors.layout.dark};
  border-right: none;
  font-size: inherit;
  transition: border-color 0.2s ease-in-out;
  border-radius: ${({theme:e})=>e.radius.square} 0 0
    ${({theme:e})=>e.radius.square};
  padding: 0 ${({theme:e})=>e.gap.small};
  background-color: ${({theme:e,prefixStyling:t,disabled:o})=>t||o?e.colors.layout.darker:e.colors.layout.darkest};
  height: ${e=>{switch(e.size){case"small":return "30px";case"large":return "50px";case"normal":default:return "40px"}}};

  svg {
    width: ${({size:e})=>e==="small"?16:e==="large"?24:20}px;
    height: ${({size:e})=>e==="small"?16:e==="large"?24:20}px;
  }
`,ia=X.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({theme:e})=>e.colors.text.light};
  border: 1px solid
    ${({theme:e,error:t,focus:o,suffixStyling:r,type:n})=>t&&!r?e.colors.accent.danger:n&&!r?e.colors.accent[n]:o&&!r?e.colors.layout.lighter:e.colors.layout.dark};
  border-left: none;
  font-size: inherit;
  transition: border-color 0.2s ease-in-out;
  border-radius: 0 ${({theme:e})=>e.radius.square}
    ${({theme:e})=>e.radius.square} 0;
  padding: 0 ${({theme:e})=>e.gap.small};
  background-color: ${({theme:e,suffixStyling:t,disabled:o})=>t||o?e.colors.layout.darker:e.colors.layout.darkest};
  height: ${e=>{switch(e.size){case"small":return "30px";case"large":return "50px";case"normal":default:return "40px"}}};

  svg {
    width: ${({size:e})=>e==="small"?16:e==="large"?24:20}px;
    height: ${({size:e})=>e==="small"?16:e==="large"?24:20}px;
  }
`,er=X.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: border-color 0.2s ease-in-out;
  color: ${({theme:e})=>e.colors.text.light};
  border: 1px solid
    ${({theme:e,error:t,focus:o,type:r})=>t?e.colors.accent.danger:r?e.colors.accent[r]:o?e.colors.layout.lighter:e.colors.layout.dark};
  border-left: none;
  padding-right: ${({theme:e,lastItem:t})=>t?e.gap.small:e.gap.tiny};
  ${({theme:e,disabled:t})=>t&&`background-color: ${e.colors.layout.darker};`};
  ${({theme:e,suffix:t,suffixContainer:o})=>t&&o?`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `:`
    border-radius: 0 ${e.radius.square}
    ${e.radius.square} 0;
  `}
  ${({suffix:e,suffixContainer:t,suffixStyling:o,lastItem:r})=>(e&&t&&!o||!r)&&"border-right: none;"}
  height: ${e=>{switch(e.size){case"small":return "30px";case"large":return "50px";case"normal":default:return "40px"}}};

  ${M} {
    cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
  }
`,aa=X(er)`
  ${M} {
    transition:
      color,
      opacity 0.2s ease-in-out;
    opacity: ${({visible:e})=>e?1:0};
    pointer-events: ${({visible:e})=>e?"auto":"none"};
  }
`,sa=X(Jo)`
  margin-top: ${({theme:e})=>e.gap.tiny};
  width: ${({width:e})=>e?d(e)?`${e}px`:e:"auto"};
`,la=X(e=>w.createElement(C,{size:"compact",weight:"medium",mb:"tiny",color:"light",span:!0,...e}))``;Qo.displayName="KitchnInput";var ca=l(Qo),A=ca;var tr=X(({as:e="a",href:t,className:o,disabled:r,onClick:n,variant:i$1,children:s,...d})=>{let[u,c]=w.useState(null);w.useEffect(()=>{(async()=>{try{let{default:h}=await import('next/link');c(h);}catch{}})();},[]),r=r||!n&&!t;let m=f=>{if(r)return f.preventDefault();n&&n(f);};return i(t)&&!t.match(/^(\/(?!\/)[^#]*|#.*)$/)?w.createElement(e,{"aria-disabled":r,href:t,className:o,target:"_blank",rel:"noopener noreferrer",onClick:m,...d},s):t&&u?w.createElement(u,{"aria-disabled":r,href:t,className:o,onClick:m,...d},s):w.createElement(e,{"aria-disabled":r,className:o,onClick:m,href:t,variant:i$1,...d},s)})`
  box-sizing: border-box;
  display: inline-flex;
  font-weight: ${({theme:e,variant:t})=>t==="blend"&&e.weight.medium};
  text-decoration: none;
  transition:
    opacity 0.2s ease-in-out,
    filter 0.2s ease-in-out;
  line-height: 1.25;
  ${({variant:e})=>e==="blend"&&`
  background-image: linear-gradient(currentColor, currentColor);
  background-size: 100% 1px;
  background-position: 0 100%;
  background-repeat: no-repeat;`};

  color: ${({theme:e,variant:t})=>t==="highlight"?e.colors.accent.primary:t==="blend"?"inherit":t==="secondary"?e.colors.text.lighter:"inherit"};

  &:hover {
    ${({theme:e,disabled:t,variant:o,onClick:r,href:n})=>(t=t||!r&&!n,`
      cursor: ${t?"default":"pointer"};
      filter: ${o&&o!=="blend"||t?"none":"brightness(0.8)"};
      ${o==="secondary"?`
  background-image: linear-gradient(currentColor, currentColor);
  background-size: 100% 1px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  color: ${e.colors.text.lightest};`:""};
    `)}
  }
`;tr.displayName="KitchnLink";var ma=l(tr),ye=ma;var or=e=>{let t={topLeft:"translate(-60px, -60px)",topRight:"translate(60px, -60px)",bottomLeft:"translate(-60px, 60px)",bottomRight:"translate(60px, 60px)"},o={topLeft:"translate(-50px, 15px) scale(0.85)",topRight:"translate(50px, 15px) scale(0.85)",bottomLeft:"translate(-50px, -15px) scale(0.85)",bottomRight:"translate(50px, -15px) scale(0.85)"};return {enter:t[e],leave:o[e]}};var $f=e=>!!e?.current;var rr={top:"-1000px",left:"-1000px",transform:"none"},da={top:-1e3,left:-1e3,right:-1e3,bottom:-1e3,width:0,height:0},ct=e=>{if(!e||!e.current)return da;let t=e.current.getBoundingClientRect();return {...t,width:t.width||t.right-t.left,height:t.height||t.bottom-t.top,top:t.top+document.documentElement.scrollTop,bottom:t.bottom+document.documentElement.scrollTop,left:t.left+document.documentElement.scrollLeft,right:t.right+document.documentElement.scrollLeft}},nr=(e,t,o)=>{let r={top:{top:`${t.top-o}px`,left:`${t.left+t.width/2}px`,transform:"translate(-50%, -100%)"},topStart:{top:`${t.top-o}px`,left:`${t.left}px`,transform:"translate(0, -100%)"},topEnd:{top:`${t.top-o}px`,left:`${t.left+t.width}px`,transform:"translate(-100%, -100%)"},bottom:{top:`${t.bottom+o}px`,left:`${t.left+t.width/2}px`,transform:"translate(-50%, 0)"},bottomStart:{top:`${t.bottom+o}px`,left:`${t.left}px`,transform:"translate(0, 0)"},bottomEnd:{top:`${t.bottom+o}px`,left:`${t.left+t.width}px`,transform:"translate(-100%, 0)"},left:{top:`${t.top+t.height/2}px`,left:`${t.left-o}px`,transform:"translate(-100%, -50%)"},leftStart:{top:`${t.top}px`,left:`${t.left-o}px`,transform:"translate(-100%, 0)"},leftEnd:{top:`${t.top+t.height}px`,left:`${t.left-o}px`,transform:"translate(-100%, -100%)"},right:{top:`${t.top+t.height/2}px`,left:`${t.right+o}px`,transform:"translate(0, -50%)"},rightStart:{top:`${t.top}px`,left:`${t.right+o}px`,transform:"translate(0, 0)"},rightEnd:{top:`${t.top+t.height}px`,left:`${t.right+o}px`,transform:"translate(0, -100%)"}};return r[e]||r.top},ir=(e,t,o,r="3px")=>{let n={top:{top:"auto",right:"auto",left:"50%",bottom:`${r}`,transform:"translate(-50%, 100%) rotate(-90deg)"},topStart:{top:"auto",right:"auto",left:`${t}`,bottom:`${r}`,transform:"translate(0, 100%) rotate(-90deg)"},topEnd:{top:"auto",right:`${t}`,left:"auto",bottom:`${r}`,transform:"translate(0, 100%) rotate(-90deg)"},bottom:{top:`${r}`,right:"auto",left:"50%",bottom:"auto",transform:"translate(-50%, -100%) rotate(90deg)"},bottomStart:{top:`${r}`,right:"auto",left:`${t}`,bottom:"auto",transform:"translate(0, -100%) rotate(90deg)"},bottomEnd:{top:`${r}`,right:`${t}`,left:"auto",bottom:"auto",transform:"translate(0, -100%) rotate(90deg)"},left:{top:"50%",right:"0",left:"auto",bottom:"auto",transform:"translate(100%, -50%) rotate(180deg)"},leftStart:{top:`${o}`,right:"0",left:"auto",bottom:"auto",transform:"translate(100%, -50%) rotate(180deg)"},leftEnd:{top:"auto",right:"0",left:"auto",bottom:`${o}`,transform:"translate(100%, 50%) rotate(180deg)"},right:{top:"50%",right:"auto",left:"0",bottom:"auto",transform:"translate(-100%, -50%) rotate(0deg)"},rightStart:{top:`${o}`,right:"auto",left:"0",bottom:"auto",transform:"translate(-100%, -50%) rotate(0deg)"},rightEnd:{top:"auto",right:"auto",left:"0",bottom:`${o}`,transform:"translate(-100%, 50%) rotate(0deg)"}};return n[e]||n.top};var ua=X(({placement:e,iconOffset:t,type:o,...r})=>{let{transform:n,top:i,left:s,right:d,bottom:u}=w.useMemo(()=>ir(e,t.x,t.y),[e]);return w.createElement(fa,{transform:n,top:i,left:s,right:d,bottom:u,type:o,...r})})`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 7px 6px 0;
  position: absolute;
  border-color: transparent
    ${({theme:e,type:t})=>{switch(t){case"danger":return h(e.colors.accent.danger,.5);case"warning":return h(e.colors.accent.warning,.5);case"info":return h(e.colors.accent.info,.5);case"success":return h(e.colors.accent.success,.5);case"secondary":return e.colors.layout.lighter;case"primary":default:return e.colors.layout.dark}}}
    transparent transparent;
`,fa=X.span`
  left: ${({left:e})=>e};
  right: ${({right:e})=>e};
  top: ${({top:e})=>e};
  bottom: ${({bottom:e})=>e};
  transform: ${({transform:e})=>e};
`,lr=ua;var ga=X(({children:e,parent:t,visible:o,offset:r,iconOffset:n,placement:i,type:s,hideArrow:d,portalCss:u,...c})=>{let m=O("tooltip"),f=w.useRef(null),[h,p]=w.useState(rr);if(!t)return null;let b=()=>{let x=nr(i,ct(t),r);p(x);};lt(b),ot(()=>b()),w.useEffect(()=>{b();},[o]);let g=x=>{x.stopPropagation(),x.nativeEvent.stopImmediatePropagation();};return m?createPortal(w.createElement(ba,{ref:f,onClick:g,rect:h,visible:o,type:s,portalCss:u,...c},w.createElement(Ve,null,!d&&w.createElement(lr,{placement:i,iconOffset:n,type:s}),e)),m):null})`
  box-sizing: border-box;
  position: absolute;
  padding: 0;
  z-index: 1000;
  width: auto;
  height: auto;
  border-radius: ${({theme:e})=>e.radius.square};
  background-color: ${({theme:e,type:t})=>{switch(t){case"danger":return e.colors.accent.danger;case"warning":return e.colors.accent.warning;case"info":return e.colors.accent.info;case"success":return e.colors.accent.success;case"secondary":return e.colors.layout.light;case"primary":default:return e.colors.layout.darkest}}};
  border: 1px solid
    ${({theme:e,type:t})=>{switch(t){case"danger":return h(e.colors.accent.danger,.5);case"warning":return h(e.colors.accent.warning,.5);case"info":return h(e.colors.accent.info,.5);case"success":return h(e.colors.accent.success,.5);case"secondary":return e.colors.layout.lighter;case"primary":default:return e.colors.layout.dark}}};
  ${({portalCss:e})=>e};
`,ba=X.div`
  opacity: ${({visible:e})=>e?1:0};
  pointer-events: ${({visible:e})=>e?"auto":"none"};
  top: ${({rect:e})=>e.top};
  left: ${({rect:e})=>e.left};
  transform: ${({rect:e})=>e.transform};
`,Ve=X.div`
  box-sizing: border-box;
  position: relative;
  height: 100%;
  padding: 0.5em 0.75em;
`,cr=ga;var pr=X(({children:e,initialVisible:t=!1,text:o,offset:r=12,placement:n="top",enterDelay:i=150,leaveDelay:s=150,trigger:d="hover",onVisibleChange:u=()=>{},onContentClick:c=()=>{},hideArrow:m=!1,type:f="primary",visible:h,portalCss:p=css``,...b})=>{let g=w.useRef(),x=w.useRef(null),[T,k]=w.useState(t),R=w.useMemo(()=>{if(!x?.current)return {x:"0.75em",y:"0.75em"};let L=ct(x);return {x:`${L.width?L.width/2:0}px`,y:`${L.height?L.height/2:0}px`}},[x?.current]),D={type:f,visible:T,offset:r,placement:n,hideArrow:m,iconOffset:R,parent:x,portalCss:p,onClick:L=>c(L,T,k)},$=L=>{let ae=()=>{clearTimeout(g.current),g.current=void 0;},H=se=>{k(se),u(se),ae();};if(ae(),L){g.current=window.setTimeout(()=>H(!0),i);return}let He=d==="click"?0:s;g.current=window.setTimeout(()=>H(!1),He);},K=L=>d==="hover"&&$(L),ge=()=>d==="click"&&$(!T);return zo(x,()=>d==="click"&&$(!1)),w.useEffect(()=>{h!==void 0&&$(h);},[h]),w.createElement("div",{ref:x,onClick:ge,onMouseEnter:()=>K(!0),onMouseLeave:()=>K(!1),...b},e,w.createElement(cr,{...D},o))})`
  width: max-content;
  display: inline-block;
  user-select: none;
`;pr.displayName="KitchnTooltip";var Pa=l(pr),mr=Pa;var Ta=X(({children:e,placement:t="bottomStart",portalCss:o=css``,hideArrow:r=!0,trigger:n="click",...i})=>{let s=Children.toArray(e).filter(m=>w.isValidElement(m)&&m.type===ur),d=Children.toArray(e).find(m=>w.isValidElement(m)&&m.type===fr),u=css`
      ${Ca} ${o}
    `;return w.createElement(mr,{role:"menu",trigger:n,text:d,portalCss:u,hideArrow:r,placement:t,onContentClick:(m,f,h)=>{let p=m.target;for(;p&&p!==m.currentTarget;){if(p.hasAttribute("data-menuitem")){h(!1);return}p=p.parentElement;}m.stopPropagation(),m.nativeEvent.stopImmediatePropagation();},offset:5,...i},s)})``,Ca=css`
  ${Ve} {
    padding: ${({theme:e})=>e.gap.tiny};
  }
`,ur=({unstyled:e,...t})=>e&&t.children?w.cloneElement(t.children,t):w.createElement(ve,{role:"menuitem",...t}),fr=X(({children:e,...t})=>w.createElement(y,{as:"ul",...t},e))``,hr=X.li.attrs({"data-menuitem":!0})`
  list-style: none;
  padding: ${({theme:e})=>e.gap.small} ${({theme:e})=>e.gap.normal};
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
  transition: background-color 0.2s ease;
  font-size: ${({theme:e})=>e.size.compact};
  border-radius: ${({theme:e})=>e.radius.square};
  width: 100%;
  ${({disabled:e})=>e&&`
    opacity: 0.5;
  `}

  ${({active:e,theme:t})=>e&&`
    background-color: ${t.colors.layout.dark};
  `}

  &:hover {
    ${({disabled:e,theme:t})=>!e&&`background-color: ${t.colors.layout.dark};`}
  }
`,ka=X(e=>w.createElement(hr,{as:ye,...e}))`
  &:hover {
    filter: brightness(1);
  }
`,$a=X(({title:e,children:t,...o})=>w.createElement(y,{role:"presentation",as:"li",...o},w.createElement(C,{size:"tiny",color:"light",px:"small",pb:"tiny",pt:"normal"},e),t))``,va=X.div`
  height: 1px;
  width: calc(100% + ${({theme:e})=>e.gap.tiny} * 2);
  background-color: ${({theme:e})=>e.colors.layout.dark};
  margin: ${({theme:e})=>e.gap.tiny} 0 ${({theme:e})=>e.gap.tiny} -${({theme:e})=>e.gap.tiny};
`,pe={Container:Ta,Button:ur,Content:fr,Item:l(hr),Link:ka,Section:$a,Divider:l(va)};var Ia=(e,t)=>e.toLocaleDateString(t?.locale?.code,{weekday:"short"}).slice(0,1),Jh=e=>e.toLocaleDateString(void 0,{month:"long",year:"numeric"}),yr=X(({placeholder:e="Select a date",multiplePlaceholder:t="%s days selected",rangePlaceholder:o="Select an end date",menuContainerProps:r,menuButtonProps:n,format:i,time:s=!1,timeStartLabel:d="Start",timeEndLabel:u="End",...c})=>{if(!i)switch(c.mode){case"range":c.selected?.from&&c.selected?.to&&isSameMonth(c.selected.from,c.selected.to)?i={weekday:"short",day:"numeric",hour:s?"numeric":void 0,minute:s?"numeric":void 0}:i={weekday:"short",month:"short",day:"numeric",hour:s?"numeric":void 0,minute:s?"numeric":void 0};break;case"single":case"multiple":default:i={weekday:"short",month:"short",day:"numeric"};break}let m={selected:!0,customModifier:!0},f=(p,b,g=!1)=>{if(b.mode!=="single")return;let x;if(g){let T=new Date(b.selected||new Date),[k,R]=p.target.value.split(":");x=new Date(T.getFullYear(),T.getMonth(),T.getDate(),parseInt(k,10),parseInt(R,10));}else x=new Date(p.target.value);isValid(x)&&b.onSelect&&b.onSelect(x,x,m,p);},h=(p,b,g=!1)=>{if(b.mode!=="range")return;let x;if(g)x=new Date(p.target.value);else {let T=new Date(b.selected?.from||new Date);x=new Date(p.target.value),x.setHours(T.getHours(),T.getMinutes());}isValid(x)&&b.onSelect&&b.onSelect({from:g?b.selected?.from:x,to:g?x:b.selected?.to},x,m,p);};return w.createElement(pe.Container,{portalCss:css`
          ${Ve} {
            padding: 0;
            width: 280px;
          }
        `,...r},w.createElement(pe.Button,{unstyled:!1,prefix:w.createElement(M,{icon:RiCalendarLine}),type:"dark",htmlType:"button",...n},w.createElement(C,{size:"small"},c.selected instanceof Date?c.selected.toLocaleDateString(void 0,i):c.selected instanceof Array&&c.mode==="multiple"&&c.selected.length>0?c.selected&&c.selected.length===1&&c.selected.every(p=>p instanceof Date)?c.selected[0].toLocaleDateString(void 0,i):t.replace("%s",c.selected.length.toString()):isDateRange(c.selected)&&c.mode==="range"?c.selected.from&&c.selected.to?isSameDay(c.selected.from,c.selected.to)?c.selected.from.toLocaleDateString(void 0,i):isSameMonth(c.selected.from,c.selected.to)?`${c.selected.from.toLocaleDateString(void 0,i)} - ${c.selected.to.toLocaleDateString(void 0,i)} ${c.selected.to.toLocaleDateString(void 0,{month:"short"})}`:`${c.selected.from.toLocaleDateString(void 0,i)} - ${c.selected.to.toLocaleDateString(void 0,i)}`:o:e)),w.createElement(pe.Content,{as:"div"},w.createElement(y,{p:"small"},w.createElement(Ra,{weekStartsOn:1,showOutsideDays:!0,formatters:{formatWeekdayName:Ia,formatCaption:p=>p.toLocaleDateString(void 0,{month:"long",year:"numeric"})},...c})),s&&w.createElement(y,{btw:1,p:"small",gap:"small"},w.createElement(y,{gap:"tiny"},c.mode==="single"&&w.createElement(y,{gap:"tiny",row:!0},w.createElement(A,{size:"small",placeholder:"mm/dd/yyyy",value:c.selected?.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"}),onBlur:p=>f(p,c),onKeyDown:p=>{p.key==="Enter"&&f(p,c);}}),w.createElement(A,{size:"small",placeholder:"hh:mm",value:c.selected?.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",timeZoneName:"short"}),onBlur:p=>f(p,c,!0),onKeyDown:p=>{p.key==="Enter"&&f(p,c,!0);}})),c.mode==="range"&&w.createElement(y,{gap:"tiny"},w.createElement(C,{ml:"tiny",size:"tiny",color:"light",span:!0},d),w.createElement(y,{gap:"tiny",row:!0},w.createElement(y,null,w.createElement(A,{size:"small",placeholder:"mm/dd/yyyy",value:c.selected?.from?.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"}),onBlur:p=>h(p,c),onKeyDown:p=>{p.key==="Enter"&&h(p,c);}})),w.createElement(y,null,w.createElement(A,{size:"small",placeholder:"hh:mm",value:c.selected?.from?.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",timeZoneName:"short"}),onBlur:p=>h(p,c,!1),onKeyDown:p=>{p.key==="Enter"&&h(p,c,!1);}}))),w.createElement(C,{ml:"tiny",size:"tiny",color:"light",span:!0},u),w.createElement(y,{gap:"tiny",row:!0},w.createElement(A,{size:"small",placeholder:"mm/dd/yyyy",value:c.selected?.to?.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"}),onBlur:p=>h(p,c,!0),onKeyDown:p=>{p.key==="Enter"&&h(p,c,!0);}}),w.createElement(A,{size:"small",placeholder:"hh:mm",value:c.selected?.to?.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",timeZoneName:"short"}),onBlur:p=>h(p,c,!0),onKeyDown:p=>{p.key==="Enter"&&h(p,c,!0);}})))))))})``,Ra=X(DayPicker)`
  &.rdp {
    .rdp-vhidden {
      display: none;
    }

    .rdp-caption {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .rdp-caption_label {
        font-size: ${({theme:e})=>e.size.compact};
      }

      .rdp-nav {
        display: flex;
        align-items: center;
        gap: ${({theme:e})=>e.gap.normal};

        .rdp-button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          padding: ${({theme:e})=>e.gap.tiny};
          transition: background-color 0.2s;
          padding: 0;

          .rdp-nav_icon {
            height: 10px;
            width: 10px;
            color: ${({theme:e})=>e.colors.text.light};
          }
        }
      }

      .rdp-caption_dropdowns {
        display: flex;
        gap: ${({theme:e})=>e.gap.small};
        align-items: center;

        .rdp-dropdown_month,
        .rdp-dropdown_year {
          position: relative;

          .rdp-dropdown {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
          }

          .rdp-caption_label {
            display: flex;
            gap: ${({theme:e})=>e.gap.tiny};
            align-items: center;
          }
        }
      }
    }

    .rdp-table {
      display: block;
      order-collapse: collapse;
      table-layout: fixed;
      margin-top: ${({theme:e})=>e.gap.small};

      .rdp-head {
        display: block;
        .rdp-head_row {
          display: flex;
          flex-wrap: nowrap;
          margin-top: ${({theme:e})=>e.gap.tiny};
          .rdp-head_cell {
            flex: 1;
            text-align: center;
            padding: 0;
            text-transform: uppercase;
            font-size: ${({theme:e})=>e.size.tiny};
            color: ${({theme:e})=>e.colors.text.light};
          }
        }
      }

      .rdp-tbody {
        display: block;
        margin-top: ${({theme:e})=>e.gap.tiny};
        .rdp-row {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          margin-top: ${({theme:e})=>e.gap.tiny};
          .rdp-cell {
            display: flex;
            flex: 1;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-size: ${({theme:e})=>e.size.normal};
            transition: background-color 0.2s;
            width: 100%;
            height: 32px;
            padding: 0;

            .rdp-button {
              z-index: 1;
              outline: none;
              display: block;
              line-height: 30px;
              width: 100%;
              height: 32px;
              border-radius: 4px;
              font-size: 14px;
              font-weight: 400;
              text-align: center;
              margin: 0;
              background-color: transparent;
              cursor: pointer;
              border: 1px solid transparent;
              transition:
                background-color 0.2s,
                border 0.2s,
                border-radius 0.2s;

              &:hover {
                border: 1px solid ${({theme:e})=>e.colors.layout.light};
              }

              &.rdp-day_outside,
              &.rdp-day_disabled {
                color: ${({theme:e})=>e.colors.text.light};
              }

              &.rdp-day_disabled {
                &:hover {
                  border: 1px solid transparent;
                  cursor: initial;
                }
              }

              &.rdp-day_today {
                background-color: ${({theme:e})=>e.colors.layout.dark};
              }

              &.rdp-day_selected {
                background-color: ${({theme:e})=>e.colors.layout.lightest};
                color: ${({theme:e})=>e.colors.text.darkest};
                border: 1px solid ${({theme:e})=>e.colors.layout.lightest};
              }

              &.rdp-day_range_middle {
                background-color: ${({theme:e})=>e.colors.layout.dark};
                color: ${({theme:e})=>e.colors.text.lightest};
                border: 1px solid transparent;
                border-radius: 0;
                height: 28px;
                line-height: 26px;

                &.rdp-day_today {
                  background-color: ${({theme:e})=>e.colors.layout.dark};
                  height: 32px;
                  line-height: 30px;
                  border-radius: 4px;
                }
              }
            }

            &:first-child {
              .rdp-button {
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
              }
            }

            &:last-child {
              .rdp-button {
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
              }
            }
          }
        }
      }
    }
  }
`;yr.displayName="KitchnCalendar";var Zh=l(yr);var Pr=X(({children:e,checked:t,onChange:o,disabled:r,fullWidth:n,indeterminate:i,label:s,...d})=>{let u=c=>{if(r)return c.preventDefault();o&&o(c);};return w.createElement(Ha,{role:"checkbox","aria-checked":t,"aria-disabled":r,disabled:r,fullWidth:n,label:s,...d},s&&w.createElement(Ba,null,s),w.createElement(Na,{label:!!s},w.createElement(Fa,null,w.createElement(Oa,{type:"checkbox",checked:t,onChange:u}),w.createElement(Tr,{checked:t,indeterminate:i,disabled:r,"aria-hidden":"true"},t?w.createElement(M,{icon:RiCheckLine,color:r?"darker":"darkest",size:16}):i&&w.createElement(M,{icon:RiSubtractLine,color:"darker",size:16}))),e&&w.createElement(Ka,null,e)))})`
  * {
    box-sizing: border-box;
  }
`,Tr=X.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  border-radius: 3px;
  height: 1rem;
  width: 1rem;
  position: relative;
  transition: all 0.2s;
  transform: rotate(0.000001deg);
  background-color: ${e=>e.disabled?h(e.theme.colors.layout.lightest,.1):e.checked?e.theme.colors.layout.lightest:"transparent"};

  color: ${e=>e.disabled?e.theme.colors.text.light:e.checked?e.theme.colors.layout.darkest:e.indeterminate?e.theme.colors.layout.light:"transparent"};
`,Ha=X.label`
  ${({label:e})=>!e&&`
  display: inline-flex;
  align-items: flex-start;
  user-select: none;
  `}
  ${({fullWidth:e})=>e&&"width: 100%;"};

  &:hover {
    ${Tr} {
      border-color: ${({theme:e,disabled:t})=>t?e.colors.layout.dark:e.colors.layout.light};
    }
  }

  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};

  ${({theme:e,disabled:t})=>t&&`
    cursor: not-allowed;
    color: ${e.colors.text.light};
    filter: brightness(0.8);
  `}
`,Ba=X.div`
  margin-bottom: 8px;
  font-size: ${({theme:e})=>e.size.small};
  font-weight: ${({theme:e})=>e.weight.medium};
  color: ${({theme:e})=>e.colors.text.dark};
`,Aa=({children:e,label:t,...o})=>t?w.createElement("div",{...o},e):w.createElement(w.Fragment,null,e),Na=X(Aa)`
  display: inline-flex;
  align-items: flex-start;
  user-select: none;
`,Fa=X.span`
  display: flex;
  position: relative;
  align-items: center;
  padding: 2px;
  margin: -2px;
`,Ka=X.span`
  margin-left: 8px;
  font-size: ${({theme:e})=>e.size.compact};
`,Oa=X.input`
  cursor: inherit;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;Pr.displayName="KitchnCheckbox";var ag=l(Pr);var Cr=X(({children:e,title:t,...o})=>w.createElement("pre",{role:"code","aria-label":t,title:t,...o},t&&w.createElement(Wa,null,w.createElement(_a,null,t)),w.createElement(Ga,null,e)))`
  position: relative;
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  border-radius: 8px;
  padding: ${({title:e})=>e?"35px 15px 15px":"15px"};
  margin: 30px 0;
  white-space: pre;
  overflow: auto;
`,Wa=X.header`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
`,_a=X.div`
  font-size: ${({theme:e})=>e.size.small};
  background-color: ${({theme:e})=>e.colors.layout.dark};
  color: ${({theme:e})=>e.colors.text.lighter};
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 5px;
`,Ga=X.code`
  color: ${({theme:e})=>e.colors.text.lightest};
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  font-size: ${({theme:e})=>e.size.small};
  line-height: 1.5;
  font-family: ${({theme:e})=>e.family.monospace};
  tab-size: 4;
  hyphens: none;
`;Cr.displayName="KitchnCode";var mg=l(Cr);var kr=X(e=>w.createElement("code",{role:"presentation",...e}))`
  display: inline-block;
  background: ${({theme:e})=>e.colors.layout.dark};
  color: ${({theme:e})=>e.colors.text.lighter};
  border-radius: 5px;
  font-family: ${({theme:e})=>e.family.monospace};
  padding: 0 5px;
  line-height: 1.5;
  white-space: pre-wrap;
`;kr.displayName="KitchnInlineCode";var gg=l(kr);var $r=X(({title:e,subtitle:t,children:o,defaultExpanded:r=!1,size:n="medium",...i})=>{let s=w.useRef(null),[d,u]=w.useState(r),[c,m]=w.useState(r?void 0:0),f=()=>{u(h=>!h);};return w.useEffect(()=>{if(!c||!d||!s.current)return;let h=new ResizeObserver(p=>{m(p[0].contentRect.height);});return h.observe(s.current),()=>{h.disconnect();}},[c,d]),w.useEffect(()=>{d&&s.current?m(s.current.getBoundingClientRect().height):m(0);},[d]),w.createElement("div",{role:"region","aria-expanded":d,...i},w.createElement(qa,{onClick:f,isOpen:d},w.createElement(Ya,null,w.createElement(Xa,{size:n},e),t&&w.createElement(Ja,null,t)),w.createElement(M,{icon:RiArrowDownSLine})),w.createElement(Za,{height:c},w.createElement(Qa,{ref:s},o)))})`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid ${({theme:e})=>e.colors.layout.dark};

  &:last-child {
    border-bottom: 1px solid ${({theme:e})=>e.colors.layout.dark};
  }

  ${({card:e,theme:t})=>e&&`
  border: 1px solid ${t.colors.layout.dark};
  border-radius: 5px;
  background: ${t.colors.layout.darker};
  margin-bottom: 10px;
  width: 100%;

  &:first-child {
    margin-top: 0;
  }
`}
`,qa=X.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: none;
  border: none;
  background-color: transparent;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;

  ${M} {
    transition: transform 0.2s;
    transform: ${({isOpen:e})=>e?"rotate(180deg)":"rotate(0deg)"};
  }
`,Ya=X.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`,Xa=X.h3`
  font-size: ${({size:e,theme:t})=>{switch(e){case"small":return t.size.small;case"medium":return t.size.medium;default:return t.size.normal}}};
  font-weight: ${({theme:e})=>e.weight.bold};
`,Ja=X.span`
  margin-top: 5px;
  font-size: ${({theme:e})=>e.size.small};
  font-weight: ${({theme:e})=>e.weight.regular};
  color: ${({theme:e})=>e.colors.text.light};
`,Za=X.div`
  overflow: hidden;
  transition: height 0.2s ease-in-out;
  height: ${({height:e})=>e?`calc(${e}px + 10px * 2)`:"0px"};
`,Qa=X.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px;
`;$r.displayName="KitchnCollapse";var es=l($r),vr=es;var os={top:-1e3,left:-1e3,right:-1e3,width:0},wr=w.memo(({visible:e,disableMatchWidth:t,children:o,parent:r})=>{let n=O("dropdown"),[i,s]=w.useState(os);if(!r)return null;let d=()=>{let{top:m,left:f,right:h,width:p}=at(r);s({top:m,left:f,right:h,width:p});};lt(d),ot(()=>{let{top:m,left:f}=at(r);(m!==i.top||f!==i.left)&&d();}),Bo(r,()=>{d();}),w.useEffect(()=>{if(!(!r||!r.current))return r.current.addEventListener("mouseenter",d),()=>{!r||!r.current||r.current.removeEventListener("mouseenter",d);}},[r]);let u=m=>{m.stopPropagation(),m.nativeEvent.stopImmediatePropagation(),m.preventDefault();},c=m=>{m.preventDefault();};return n?createPortal(w.createElement(y,{display:e?"flex":"none",position:"absolute",top:i.top+2,left:i.left,zIndex:1e3,width:t?"auto":i.width,minWidth:t?i.width:"auto",onMouseDown:c,onClick:u},o),n):null});wr.displayName="KitchenDropdown";var rs=l(wr),Er=rs;var Mr=({visible:e,disableMatchWidth:t,children:o})=>{let{ref:r}=nt();return w.createElement(Er,{parent:r,visible:e,disableMatchWidth:t},w.createElement(y,{br:"square",bc:"dark",bg:"darkest",p:"tiny",maxH:250,overflow:"auto",onClick:i=>{i.preventDefault(),i.stopPropagation(),i.nativeEvent.stopImmediatePropagation();}},o))};Mr.displayName="KitchenComboboxDropdown";var ns=l(Mr),Lr=ns;var Rr=({children:e,textProps:t,...o})=>w.createElement(y,{gap:"small",padding:"small",align:"center",justify:"center",...o},w.createElement(C,{align:"center",size:"compact",color:"light",...t},e));Rr.displayName="KitchenComboboxEmpty";var is=l(Rr),Lt=is;var Dr=X(({value:e,children:t,isLabelOnly:o,onClick:r,...n})=>{let{value:i,updateValue:s,updateVisible:d}=nt(),u=m=>{s&&s(e),d&&d(!1),r&&r(m);},c=w.useMemo(()=>i===e,[e,i]);return w.createElement(y,{br:"square",p:"tiny",cursor:"pointer",onClick:u,bg:c?"dark":"darkest",...n},o?w.createElement(C,{size:"compact",truncate:!0,span:!0},t):w.createElement(C,{size:"compact",span:!0},t))})`
  transition: all 0.2s;
  &:hover {
    background-color: ${({theme:e})=>e.colors.layout.dark};
  }
`;Dr.displayName="KitchenComboboxItem";var ss=l(Dr),zr=ss;var Br=({children:e,textProps:t,...o})=>w.createElement(y,{gap:"small",padding:"small",align:"center",justify:"center",...o},w.createElement(C,{align:"center",size:"compact",color:"light",...t},e));Br.displayName="KitchenComboboxSearching";var ls=l(Br),It=ls;var ps=e=>e.map((t,o)=>{if(w.isValidElement(t))return w.cloneElement(t,{key:o});let r=t;return w.createElement(zr,{key:o,value:r.value,isLabelOnly:!0},r.label)}),Ar=w.forwardRef(({containerProps:e,initialValue:t="",clearable:o=!1,searching:r,onChange:n,onSelect:i,onSearch:s,value:d,disabled:u,disableFreeSolo:c=!1,disableMatchWidth:m=!1,options:f=[],children:h,...p},b)=>{let g=w.useRef(),x=w.useRef(null),T=w.useRef(null),[k,R,D]=xe(t),[$,K]=w.useState(t),[ge,L]=w.useState(!1);w.useImperativeHandle(b,()=>T.current);let[,ae]=j$1(h,It),[,H]=j$1(h,Lt),He=w.useMemo(()=>{let I=ae&&w.Children.count(ae)>0,bt=H&&w.Children.count(H)>0;return r?I?ae:w.createElement(It,null,"Searching..."):f.length===0?k===""?null:bt?H:w.createElement(Lt,null,"No results"):ps(f)},[r,f,k]),se=w.useMemo(()=>o&&r===void 0,[o,r]),be=I=>{u||(K(I),i&&i(I),R(I),T.current&&T.current.focus());},Ue=I=>L(I),gt=I=>{k===I.target.value||I.target.value===""?L(!1):L(!0),s&&s(I.target.value),R(I.target.value);},je=()=>{c&&(!k||k===""||k!==$&&R($));};w.useEffect(()=>{n&&n(k);},[k]),w.useEffect(()=>{d!==void 0&&R(d);},[d]);let Be=w.useMemo(()=>({ref:x,value:k,updateValue:be,visible:ge,updateVisible:Ue}),[k,ge]),Ae=I=>{clearTimeout(g.current),L(I&&k===""?!1:I),I?s&&s(D.current):g.current=window.setTimeout(()=>{je(),clearTimeout(g.current);},100);},Ot={...p,disabled:u,value:k};return w.createElement(rt.Provider,{value:Be},w.createElement(y,{ref:x,...e},w.createElement(A,{ref:T,onChange:gt,onFocus:()=>Ae(!0),onBlur:()=>Ae(!1),onClick:()=>Ae(!0),clearable:se,...Ot}),w.createElement(Lr,{visible:ge,disableMatchWidth:m},He)))});Ar.displayName="Combobox";var Nr=X(Ar)``;Nr.displayName="KitchnCombobox";var Pb=l(Nr);var Kr=X(({children:e,show:t,onDismiss:o,onAnimationDone:r,height:n,...i})=>{let s=O("drawer"),d=w.useRef(null),[u,c]=w.useState(null),m=w.useCallback((p=!0)=>{u&&c("exit"),p&&o&&o(),setTimeout(()=>{c(null),r&&u==="exit"&&r();},210);},[u,o,r]),f=p=>{p.target===p.currentTarget&&m();},{bindings:h}=it(()=>{m();},27,{disableGlobalEvent:!0});return w.useEffect(()=>{t?(document.body.style.overflow="hidden",c("entrance"),setTimeout(()=>{d.current&&d.current.focus();},100)):(document.body.style.overflow="unset",m(!1));},[m,t]),s?createPortal(t&&u||u?w.createElement("div",{role:"dialog","aria-modal":"true",onClick:f,tabIndex:-1,ref:d,...h,...i},w.createElement(ds,{animationState:u,height:n,tabIndex:0},e)):null,s):null})`
  top: 0px;
  left: 0px;
  width: 100vw;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  position: fixed;
  z-index: 101;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
`,ds=X.div`
  width: 100%;
  max-width: 100%;
  background-color: ${({theme:e})=>e.colors.layout.darkest};
  color: ${({theme:e})=>e.colors.layout.lightest};
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({theme:e})=>e.colors.layout.dark};
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  overflow-y: auto;
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: ${({animationState:e})=>e==="entrance"?Mo:Lo};
  ${({height:e})=>e&&`height: ${e}px`};
`;Kr.displayName="KitchnDrawer";var us=l(Kr),Or=us;var Wr=X(({as:e="span",children:t,width:o,height:r,show:n=!0,animated:i=!0,...s})=>!n&&!t?w.createElement(w.Fragment,null):!n&&t?t:w.createElement(e,{role:"status","aria-busy":n?"true":"false","aria-hidden":!n,width:o,height:r,show:n,animated:i,...s},t))`
  ${({children:e,show:t=!0,width:o,height:r,shape:n,theme:i$1,animated:s=!0})=>e?`
        position: relative;
        display: block;
        width: ${o?"100%":"auto"};
        max-width: ${o?i(o)?o:`${o}px`:"unset"};
        min-height: ${r?i(r)?r:`${r}px`:"auto"};
        ${t?`
            overflow: hidden;
            border-radius: ${n==="square"?"0":n==="round"?"99999px":"8px"};
            &::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 100;
              user-select: none;
              cursor: default;
              border-radius: ${n==="square"?"0":n==="round"?"99999px":"8px"};
              background-image: linear-gradient(
                270deg,
                ${i$1.colors.layout.darkest},
                ${i$1.colors.layout.dark},
                ${i$1.colors.layout.dark},
                ${i$1.colors.layout.darkest}
              );
              background-size: 400% 100%;
              animation: ${s?"skeleton 8s ease-in-out infinite":"none"};
            }
        `:""}
      `:`
          display: block;
          width: 100%;
          user-select: none;
          cursor: default;
          max-width: ${o?i(o)?o:`${o}px`:"24px"};
          min-height: ${r?i(r)?r:`${r}px`:"24px"};
          border-radius: ${n==="square"?"0":n==="round"?"99999px":"8px"};
          background-size: 400% 100%;
          background-image: linear-gradient(
            270deg,
            ${i$1.colors.layout.darkest},
            ${i$1.colors.layout.dark},
            ${i$1.colors.layout.dark},
            ${i$1.colors.layout.darkest}
          );
          animation: ${s?"skeleton 8s ease-in-out infinite":"none"};
  `}

  ${({boxHeight:e,height:t})=>e&&Number.isFinite(t)&&e-(t||24)>0&&`margin-bottom: ${e-(t||24)}px`};

  @keyframes skeleton {
    0% {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }
`;Wr.displayName="KitchnSkeleton";var hs=l(Wr),de=hs;var Dt=X(({checkbox:e,children:t,thumbnail:o,menuContent:r,actions:n,placeholder:i=!1,...s})=>{let d=w.Children.map(t,u=>w.isValidElement(u)?w.cloneElement(u,{placeholder:i}):u);return w.createElement(y,{bg:"darkest",p:"normal",bw:1,br:"square",...s},w.createElement(y,{gap:"small",align:"center",row:!0},w.createElement(de,{show:i},e),w.createElement(de,{show:i},o),d,w.createElement(de,{show:i},n),w.createElement(de,{show:i},r&&w.createElement(pe.Container,{placement:"bottomEnd"},w.createElement(pe.Button,{type:"dark",variant:"ghost",size:"small"},w.createElement(M,{icon:RiMoreLine})),w.createElement(pe.Content,{width:200},r)))))})``,Gr=X(Dt)`
  &${Dt}+${Dt} {
    position: relative;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    &::before {
      content: "";
      height: calc(${({theme:e})=>e.radius.square} - 1px);
      display: block;
      position: absolute;
      left: -1px;
      right: -1px;
      top: calc(${({theme:e})=>e.radius.square} * -1);
      background: ${({theme:e})=>e.colors.layout.darkest};
      border-left: 1px solid ${({theme:e})=>e.colors.layout.dark};
      border-right: 1px solid ${({theme:e})=>e.colors.layout.dark};
    }
  }
`;Gr.displayName="KitchnEntity";var Vb=l(Gr);var bs=X(({...e})=>w.createElement(C,{size:e.label?"small":"compact",weight:e.label?"regular":"semiBold",color:e.label?"light":e.active?"lightest":"light",transform:e.label?"uppercase":"none",truncate:!0,span:!0,...e}))``,xs=X(({...e})=>w.createElement(C,{size:"compact",color:"light",truncate:!0,span:!0,...e}))``,Vr=X(({active:e=!0,title:t,label:o,description:r,placeholder:n,...i})=>w.createElement(y,{align:"center",flex:1,minW:1,maxW:"100%",gap:"tiny",row:!0,...i},w.createElement(y,{minW:1,gap:n?"tiny":void 0,maxW:"100%"},t&&w.createElement(de,{show:n},w.createElement(bs,{label:o,active:e},t)),r&&w.createElement(de,{show:n},w.createElement(xs,null,r))),i.avatar))``;Vr.displayName="KitchnEntityField";var tx=l(Vr);var qr=X(({rect:e,visible:t,hoverHeightRatio:o=1,hoverWidthRatio:r=1,activeOpacity:n=.8,...i})=>{let s=w.useRef(null),d=Ko(_o(e)),u=e.width*r,c=e.height*o;return w.createElement(ys,{role:"presentation","aria-hidden":!t,ref:s,width:u,height:c,left:e.left+(e.width-u)/2,top:e.elementTop+(e.height-c)/2,transition:d?"opacity":"opacity, width, left, top",visible:t,activeOpacity:n,...i})})`
  opacity: ${({visible:e,activeOpacity:t})=>e?t:0};
`,ys=X.div`
  position: absolute;
  background-color: ${({theme:e})=>e.colors.layout.dark};
  border-radius: ${({theme:e})=>e.radius.square};
  width: ${({width:e})=>e}px;
  height: ${({height:e})=>e}px;
  left: ${({left:e})=>e}px;
  top: ${({top:e})=>e}px;
  transition: 0.15s ease;
  transition-property: ${({transition:e})=>e};
`;qr.displayName="KitchnHighlight";var Ps=l(qr),ft=Ps;var Xr=X(({tabs:e,disabled:t=!1,selected:o,setSelected:r,hoverHeightRatio:n=.7,hoverWidthRatio:i$1=1.05,highlight:s=!0,...d})=>{let u=w.useRef(null),[c,m]=w.useState(!1),{rect:f$1,setRect:h}=st(),p=g=>{g.target&&(h(g,()=>u.current),s&&m(!0));},b=(g,x)=>{t?g.preventDefault():r(x.value);};return w.createElement("div",{role:"tablist",ref:u,onMouseLeave:()=>m(!1),...d},w.createElement(ft,{rect:f$1,visible:c,hoverHeightRatio:n,hoverWidthRatio:i$1}),e&&e.map(g=>w.createElement(Ht,{role:"tab",key:g.value,onClick:x=>b(x,g),active:o===g.value,onMouseOver:p,disabled:t,...g},w.createElement(w.Fragment,null,g.icon&&g.icon),w.createElement(w.Fragment,null,i(g.title)?f(g.title):g.title))))})`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  color: ${({theme:e})=>e.colors.accent.dark};
  font-weight: ${({theme:e})=>e.weight.medium};
  padding-bottom: 1px;
  box-shadow: 0 -1px 0 ${({theme:e})=>e.colors.layout.dark} inset;
`,Ht=X.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: ${({disabled:e})=>e?"default":"pointer"};
  color: ${({theme:e,active:t,disabled:o})=>o?e.colors.text.darker:t?e.colors.text.lightest:e.colors.text.light};
  margin: 0 0 -1px;
  user-select: none;
  padding: 6px ${({theme:e})=>e.gap.small};
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
  margin-bottom: -1px;
  outline: 0;
  white-space: nowrap;
  border-bottom: ${({theme:e,active:t})=>`1px solid ${t?e.colors.layout.lightest:"transparent"}`};
  transition: all 0.2s;
  z-index: 1;

  svg {
    max-height: 1em;
    margin-right: ${({theme:e})=>e.gap.tiny};
  }

  &:hover {
    color: ${({theme:e,disabled:t})=>t?e.colors.text.darker:e.colors.text.lightest};
  }
`;Xr.displayName="KitchnTabs";var Bt=l(Xr);var Ts=X(({children:e,...t})=>w.createElement(_e,{ml:"auto",gap:"normal",row:!0,...t},e))``,Jr=X(({children:e,...t})=>w.createElement(Ke,{color:"lighter",...t},e))`
  font-size: ${({theme:e})=>e.size.small};
  align-self: center;
`,Zr=X.footer`
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  border-top: 1px solid ${({theme:e})=>e.colors.layout.dark};
  cursor: ${({disabled:e})=>e&&"not-allowed"};
  background: ${({theme:e,disabled:t,highlight:o})=>t||o?e.colors.layout.darkest:e.colors.layout.darker};
`,Cs=X(({children:e,...t})=>w.createElement("div",{role:"group",...t},e))`
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  border-color: ${({theme:e,type:t})=>t&&e.colors.accent[t]};
  border-radius: ${({theme:e})=>e.radius.square};
  ${({tabs:e})=>e&&`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `}
  background: ${({theme:e})=>e.colors.layout.darkest};
  cursor: ${({disabled:e})=>e&&"not-allowed"};

  ${Zr} {
    border-color: ${({theme:e,type:t})=>t&&e.colors.accent[t]};
    background-color: ${({theme:e,type:t})=>t&&h(e.colors.accent[t],.2)};

    ${Jr} {
      color: ${({theme:e,type:t})=>t&&e.colors.accent[t]};
    }
  }
`,ks=X(_e)`
  padding: 24px;
  cursor: ${({disabled:e})=>e&&"not-allowed"};
  background: ${({theme:e,disabled:t})=>t&&e.colors.layout.darker};
`,$s=X(({children:e,...t})=>w.createElement(Ke,{h4:!0,...t},e))`
  font-size: ${({theme:e})=>e.size.medium};
  font-weight: ${({theme:e})=>e.weight.semiBold};
`,vs=X(Ke)`
  font-size: ${({theme:e})=>e.size.small};
  margin: 12px 0;
`,ws=e=>w.isValidElement(e)&&e.type===Ss.Container,Es=X(({children:e,tabs:t,...o})=>{let[r,n]=w.useState(String(0)),i=w.Children.toArray(e);return w.createElement(_e,{...o},w.createElement(Bt,{tabs:t.map((s,d)=>({title:s,value:String(d)})),selected:r,setSelected:n}),i.map((s,d)=>ws(s)&&r===String(d)?w.cloneElement(s,{tabs:!0}):null))})`
  ${Bt} {
    padding: 8px 16px 0;
    background: ${({theme:e})=>e.colors.layout.darkest};
    box-shadow: none;
    border: 1px solid ${({theme:e})=>e.colors.layout.dark};
    border-bottom: none;
    border-top-left-radius: ${({theme:e})=>e.radius.square};
    border-top-right-radius: ${({theme:e})=>e.radius.square};

    ${Ht} {
      font-size: ${({theme:e})=>e.size.compact};
    }
  }
`,Ss={Container:l(Cs),Content:l(ks),Title:l($s),Subtitle:l(vs),Footer:l(Zr),FooterStatus:l(Jr),FooterActions:l(Ts),Tabs:l(Es)};var en=X(({children:e,subfooter:t,...o})=>w.createElement("footer",{role:"contentinfo",...o},w.createElement(Ms,null,e),t&&w.createElement(Is,null,t)))`
  position: relative;
  box-sizing: border-box;
  padding: ${({theme:e})=>e.gap.normal} 0;
`,Ms=X.nav`
  max-width: ${({theme:e})=>e.breakpoint.desktop};
  margin: 0 auto;
  flex-wrap: nowrap;
  padding: 0 ${({theme:e})=>e.gap.large};
  display: grid;
  grid-template-columns: ${({children:e})=>`repeat(${Math.min(w.Children.count(e),4)}, 1fr)`};
  gap: ${({theme:e})=>e.gap.normal};

  @media (max-width: ${({theme:e})=>e.breakpoint.laptop}) {
    grid-template-columns: ${({children:e})=>`repeat(${Math.min(w.Children.count(e),3)}, 1fr)`};
  }

  @media (max-width: ${({theme:e})=>e.breakpoint.tablet}) {
    grid-template-columns: ${({children:e})=>`repeat(${Math.min(w.Children.count(e),2)}, 1fr)`};
  }

  @media (max-width: ${({theme:e})=>e.breakpoint.mobile}) {
    grid-template-columns: ${({children:e})=>`repeat(${Math.min(w.Children.count(e),1)}, 1fr)`};
  }
`,zx=X.div``,Hx=X(({title:e,children:t,...o})=>{let{isMobile:r}=we();return r?w.createElement(vr,{title:e},w.createElement(Qr,null,t)):w.createElement("div",{...o},w.createElement("label",{htmlFor:e},w.createElement(Ls,null,e)),w.createElement(Qr,null,t))})``,Ls=X.h2`
  margin: ${({theme:e})=>e.gap.small} 0;
  font-weight: ${({theme:e})=>e.weight.medium};
`,Qr=X.ul`
  color: ${({theme:e})=>e.colors.text.light};
  display: grid;
  grid-template-columns: 1fr 1fr;
  list-style-type: none;
  margin: 0;
  padding: 0;
  gap: ${({theme:e})=>e.gap.tiny} ${({theme:e})=>e.gap.small};

  @media (max-width: ${({theme:e})=>e.breakpoint.mobile}) {
    grid-template-columns: 1fr;
  }
`,Bx=X(({children:e,href:t,...o})=>w.createElement("li",{role:"listitem",...o},w.createElement(ye,{href:t},e)))`
  ${ye} {
    color: ${({theme:e})=>e.colors.text.lighter};
    font-size: ${({theme:e})=>e.size.compact};
    text-decoration: none;
  }
`,Is=X.section`
  font-size: ${({theme:e})=>e.size.small};
  max-width: ${({theme:e})=>e.breakpoint.desktop};
  margin: 0 auto;
  margin-top: ${({theme:e})=>e.gap.normal};
  padding: 0 ${({theme:e})=>e.gap.large};
`;en.displayName="KitchnFooter";var Ax=l(en);var tn=X(({src:e,alt:t,...o})=>w.createElement("img",{src:e,alt:t,draggable:!1,...o}))`
  ${({objectFit:e})=>e&&`object-fit: ${e};`}
`;tn.displayName="KitchnImage";var _x=l(tn);var on=w.forwardRef(({name:e,control:t,controllerProps:o,...r},n)=>w.createElement(Controller,{name:e,control:t,...o,rules:{...o?.rules},render:({field:{onBlur:i,onChange:s,value:d,name:u},fieldState:{error:c},formState:{isSubmitting:m}})=>w.createElement(A,{...r,ref:n,name:u,value:d,onChange:s,onBlur:i,errorMessage:c?.message,disabled:m})}));on.displayName="KitchnControlledInput";var Qx=l(on);var rn=forwardRef(({hideToggle:e=!1,...t},o)=>{let r=w.useRef(null),[n,i]=w.useState(!1);w.useImperativeHandle(o,()=>r.current);let s=()=>{i(c=>!c),r&&r.current&&r.current.focus();},d=w.useMemo(()=>({...t,ref:r,clickableIcon:!0,onIconClick:s,htmlType:n?"text":"password"}),[t,s,n,r]),u=w.useMemo(()=>e?null:n?RiEyeLine:RiEyeCloseLine,[e,n]);return w.createElement(A,{suffixIcon:u,...t,...d})});rn.displayName="PasswordInput";var nn=X(rn)``;nn.displayName="KitchnPasswordInput";var sy=l(nn);var an=X(e=>w.createElement("li",{role:"listitem",...e}))`
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
`;an.displayName="KitchnListItem";var Os=l(an),sn=Os;var ln=X(e=>w.createElement("ol",{role:"list",...e}))`
  padding: 0;
  margin: 15px;
  margin-left: 25px;
  list-style-type: decimal;
`;ln.displayName="KitchnOrderedList";var gy=l(ln);var cn=X(e=>w.createElement("ul",{role:"list",...e}))`
  padding: 0;
  list-style-type: none;
  margin: 15px;
  margin-left: 25px;
  ${sn}::before {
    content: "-";
    color: ${e=>e.theme.colors.text.darker};
    margin-left: -15px;
    display: inline-block;
    position: absolute;
  }
`;cn.displayName="KitchnUnorderedList";var Cy=l(cn);var pn=X(({id:e,...t})=>{let o=`#${e}`;return w.createElement(ye,{id:e,href:o,...t})})``;pn.displayName="KitchnFragmentLink";var My=l(pn);var Ys=X(({active:e,children:t,onClickOutside:o,onEnterKeyPress:r,onAnimationDone:n,...i})=>{let s=O("modal"),d=w.useRef(null),{isMobile:u}=we(),[c,m]=w.useState(null),f=w.useCallback((b=!0)=>{c&&m("exit"),b&&o&&o(),setTimeout(()=>{m(null),n&&n();},210);},[c,o,n]),h=b=>{b.target===b.currentTarget&&f();};w.useEffect(()=>{u&&m(null),e?(document.body.style.overflow="hidden",m("entrance"),setTimeout(()=>{d.current&&d.current.focus();},100)):(document.body.style.overflow="unset",f(!1));},[e,c,f,u,n]);let{bindings:p}=it(b=>{switch(b.keyCode){case 13:r&&r();break;case 27:o&&o();break}},[27,13],{disableGlobalEvent:!0});return s?u?w.createElement(Or,{show:e,onDismiss:f,onAnimationDone:n,...p},t):createPortal(e&&c||c?w.createElement("div",{role:"dialog","aria-modal":"true",onClick:h,ref:d,tabIndex:-1,...p,...i},w.createElement(Xs,{animationState:c},w.createElement(Js,null,t))):null,s):null})`
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
`,Xs=X.div`
  width: 540px;
  max-height: 80vh;
  max-width: 100%;
  background-color: ${({theme:e})=>e.colors.layout.darkest};
  color: ${({theme:e})=>e.colors.layout.lightest};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  overflow: hidden;
  overflow-y: auto;
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: ${({animationState:e})=>e==="entrance"?wo:Eo};
`,Js=X.div`
  overflow: auto;
  display: block;
`,Zs=X.div`
  padding: 20px;
`,Qs=X(({...e})=>w.createElement(y,{header:!0,gap:"small",mb:"small",...e}))``,el=X(({...e})=>w.createElement(C,{h3:!0,size:"large",weight:"semiBold",...e}))``,tl=X(({...e})=>w.createElement(C,{...e}))``,ol=X.footer`
  position: sticky;
  bottom: 0;
  border-top: 1px solid ${({theme:e})=>e.colors.layout.dark};
  background-color: ${({theme:e})=>e.colors.layout.darker};
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;
`,rl=X(e=>w.createElement(ve,{...e}))``,nl=X.div`
  padding: 20px;
  border-top: 1px solid ${({theme:e})=>e.colors.layout.dark};
  border-bottom: 1px solid ${({theme:e})=>e.colors.layout.dark};
  background-color: ${({theme:e})=>e.colors.layout.darker};
  margin: 0 -20px;
`,jy={Modal:l(Ys),Body:l(Zs),Header:l(Qs),Title:l(el),Subtitle:l(tl),Actions:l(ol),Action:l(rl),Inset:l(nl)};var mn=X(({as:e="div",type:t,action:o,label:r=!0,size:n,children:i,...s})=>{let{theme:d}=Go();return w.createElement(e,{role:"note",size:n,...s},w.createElement(y,{align:"center",gap:"small",row:!0},r&&w.createElement(cl,null,w.createElement(M,{color:"inherit",icon:t==="success"?RiCheckboxCircleLine:t==="danger"?RiAlarmWarningLine:t==="warning"?RiErrorWarningLine:RiInformationLine,size:n==="small"?d.size.compact:n==="large"?d.size.large:d.size.medium})),w.createElement(pl,null,i)),o&&w.createElement(ml,null,o))})`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  flex: 1;
  gap: 10px;
  font-weight: ${({theme:e})=>e.weight.light};
  border-radius: 8px;
  background-color: ${({theme:e,type:t,fill:o})=>{if(o)switch(t){case"danger":return e.colors.accent.danger;case"warning":return e.colors.accent.warning;case"info":return e.colors.accent.info;case"success":return e.colors.accent.success;case"secondary":return e.colors.layout.light;case"primary":default:return e.colors.layout.dark}return "transparent"}};

  color: ${({theme:e,type:t,fill:o})=>{if(o)switch(t){case"danger":case"warning":case"info":case"success":case"secondary":return e.colors.accent.light;case"primary":default:return e.colors.text.lightest}else switch(t){case"danger":return e.colors.accent.danger;case"warning":return e.colors.accent.warning;case"info":return e.colors.accent.info;case"success":return e.colors.accent.success;case"secondary":return e.colors.text.light;case"primary":default:return e.colors.text.lightest}}};

  padding: ${e=>{switch(e.size){case"small":return "4px 8px";case"large":return "12px 16px";case"normal":default:return "8px 12px"}}};

  font-size: ${e=>{switch(e.size){case"small":return e.theme.size.small;case"large":return e.theme.size.normal;case"normal":default:return e.theme.size.compact}}};

  border: ${({theme:e,type:t})=>{switch(t){case"danger":return `1px solid ${h(e.colors.accent.danger,.5)}`;case"warning":return `1px solid ${h(e.colors.accent.warning,.5)}`;case"info":return `1px solid ${h(e.colors.accent.info,.5)}`;case"success":return `1px solid ${h(e.colors.accent.success,.5)}`;case"secondary":return `1px solid ${h(e.colors.layout.light,.5)}`;case"primary":default:return `1px solid ${h(e.colors.layout.dark,.5)}`}}};
`,cl=X.span`
  font-size: inherit;
  color: inherit;
`,pl=X.span`
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  text-align: left;
`,ml=X.div``;mn.displayName="KitchnNote";var rP=l(mn);var dn=X(({value:e,max:t=100,colors:o,states:r,title:n=!0,checkpointTitle:i=!0,checkpointStyle:s="round",...d})=>{let u=w.useRef(null),[c,m]=w.useState(0),[f,h]=w.useState(null);w.useEffect(()=>{u.current&&m(u.current.clientWidth),window.addEventListener("resize",p);},[]);let p=()=>{u.current&&m(u.current.clientWidth);},b=o?Object.keys(o).map(T=>parseInt(T,10)).filter(T=>T<=e).map(T=>o[T]).pop():void 0,g=r?Object.keys(r).map(T=>parseInt(T,10)).filter(T=>T<=e).map(T=>r[T]).pop():void 0,{isMobile:x}=we();return w.createElement(ul,{role:"progressbar","aria-valuenow":e,"aria-valuemin":0,"aria-valuemax":t,states:r,ref:u},r&&n&&w.createElement(fl,{visible:!!g},g||"unknow state"),w.createElement(dl,{value:e,max:t,...d,background:b,checkpointStyle:s}),w.createElement(hl,null,r&&Object.keys(r).map(T=>{let k=parseInt(T,10),R=k<=e,D=k===0,$=k===t;return w.createElement(w.Fragment,null,w.createElement(gl,{"aria-hidden":"true",key:k,value:k,color:R?b:void 0,first:D,last:$,onMouseEnter:()=>h(k),onMouseLeave:()=>h(null),title:r&&n,max:t,amount:Object.keys(r).length,checkpointStyle:s}),!x&&i&&w.createElement(un,{"aria-hidden":"true",first:D,last:$,active:R&&c>0||f===k},r[k]))})))})`
  appearance: none;
  border: none;
  height: 10px;
  display: block;
  vertical-align: unset;
  width: 100%;

  &::-webkit-progress-bar {
    border-radius: 5px;
    background-color: ${({theme:e,checkpointStyle:t})=>t==="bar"?"transparent":e.colors.layout.dark};
  }

  &::-webkit-progress-value {
    border-radius: 5px;
    transition: all 0.1s ease-in-out;
  }
`,dl=X.progress`
  &::-webkit-progress-value {
    background: ${({theme:e,background:t,checkpointStyle:o})=>o==="bar"?"transparent":t||e.colors.layout.lightest};
  }
`,ul=X.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({states:e,theme:t})=>e&&`margin-bottom: ${t.gap.normal};`}
`,fl=X.span`
  margin-bottom: 15px;
  font-size: ${({theme:e})=>e.size.small};
  font-style: italic;
  font-weight: ${({theme:e})=>e.weight.bold};
  color: ${({theme:e})=>e.colors.text.light};
  opacity: ${({visible:e})=>e?1:0};
`,hl=X.div`
  display: flex;
  gap: ${({theme:e})=>e.gap.small};
`,un=X.span`
  margin-top: ${({theme:e})=>e.gap.normal};
  opacity: 0;
  font-size: ${({theme:e})=>e.size.small};
  font-style: italic;
  color: ${({theme:e})=>e.colors.text.light};
  transition: all 0.3s ease-in-out;
  flex: 1;
  ${({active:e})=>e&&"opacity: 0.9;"};
  text-align: ${({first:e,last:t})=>e?"left":t?"right":"center"};
`,gl=X.div`
  position: absolute;
  top: ${({title:e,checkpointStyle:t})=>e?`${t==="bar"?28:24}px`:`${t==="bar"?0:-4}px`};
  left: ${({value:e,max:t})=>`${e*100/t}%`};
  width: ${({checkpointStyle:e,amount:t})=>e==="bar"?`calc(${100/t}% - 2px)`:"18px"};
  height: ${({checkpointStyle:e})=>e==="bar"?"10px":"18px"};
  border-radius: ${({theme:e})=>e.radius.round};
  ${({checkpointStyle:e,first:t,last:o})=>`
    ${!t&&e==="bar"?"border-top-left-radius: 0; border-bottom-left-radius: 0;":""}
    ${!o&&e==="bar"?"border-top-right-radius: 0; border-bottom-right-radius: 0;":""}
  `};
  background: ${({theme:e,color:t,checkpointStyle:o})=>o==="bar"?t||e.colors.layout.dark:t||e.colors.layout.light};
  z-index: 1;
  transform: ${({value:e,max:t,first:o,last:r})=>o?"translateX(0)":r?"translateX(-100%)":`translateX(-${e*100/t}%)`};

  &:hover {
    ${un} {
      opacity: 1;
    }
  }
`;dn.displayName="KitchnProgress";var cP=l(dn);var fn=forwardRef(({size:e="normal",label:t,placeholder:o,prefix:r,suffix:n=w.createElement(RiArrowDownSLine,null),disabled:i,children:s,...d},u)=>w.createElement(yl,{size:e},t&&w.createElement(Pl,null,t),w.createElement(Tl,null,r&&w.createElement(Nt,null,r),n&&w.createElement(Ft,null,n),w.createElement(Cl,{"aria-label":t,size:e,prefix:r,suffix:n,placeholder:o,disabled:i,defaultValue:o,ref:u,...d},o&&w.createElement("option",{disabled:!0,value:o},o),s))));fn.displayName="Select";var hn=X(fn)``,yl=X(e=>w.createElement(y,{...e,label:!0}))`
  font-size: ${({size:e,theme:t})=>{switch(e){case"small":return t.size.tiny;case"large":return t.size.normal;case"normal":default:return t.size.small}}};
`,Pl=X(e=>w.createElement(C,{size:"compact",weight:"medium",mb:"small",color:"light",span:!0,...e}))``,Nt=X.span`
  box-sizing: border-box;
  display: flex;
  left: 8px;
  position: absolute;
  pointer-events: none;
`,Ft=X.span`
  box-sizing: border-box;
  display: flex;
  right: 8px;
  position: absolute;
  pointer-events: none;
`,Tl=X.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  position: relative;

  ${Nt}, ${Ft} {
    transition: color 0.2s ease-in-out;
    color: ${({theme:e})=>e.colors.text.lighter};
  }

  &:hover {
    ${Nt}, ${Ft} {
      color: ${({theme:e})=>e.colors.text.lightest};
    }
  }
`,Cl=X.select`
  width: 100%;
  padding: 0 ${({theme:e})=>e.gap.small};
  height: ${e=>{switch(e.size){case"small":return "30px";case"large":return "50px";case"normal":default:return "40px"}}};
  font-size: inherit;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  appearance: none;
  border-radius: ${({theme:e})=>e.radius.square};
  background-color: ${({theme:e,disabled:t})=>t?e.colors.layout.darker:e.colors.layout.darkest};
  border: 1px solid ${({theme:e})=>e.colors.layout.dark};
  ${({theme:e,prefix:t})=>t&&`padding-left: ${e.gap.large};`}
  ${({theme:e,suffix:t})=>t&&`padding-right: ${e.gap.large};`}

  option {
    font-size: inherit;
  }

  &:hover,
  &:focus {
    border-color: ${({theme:e})=>e.colors.layout.light};
  }
`;hn.displayName="KitchnSelect";var yP=l(hn);var gn=X(({...e})=>w.createElement("span",{role:"presentation",...e}))`
  display: block;
  width: 1px;
  height: 1px;
  min-width: 1px;
  min-height: 1px;
  margin-left: calc(
    ${e=>e.x?e.theme.gap[e.x]||(d(e.x)?`${e.theme.gap.normal} * ${e.x}`:e.x):"1px"} - 1px
  );
  margin-top: calc(
    ${e=>e.y?e.theme.gap[e.y]||(d(e.y)?`${e.theme.gap.normal} * ${e.y}`:e.y):"1px"} - 1px
  );
`;gn.displayName="KitchnSpacer";var vP=l(gn);var xn=X(({tabs:e,disabled:t=!1,selected:o,setSelected:r,hoverHeightRatio:n=1,hoverWidthRatio:i$1=1,highlight:s=!0,...d})=>{let u=w.useRef(null),[c,m]=w.useState(!1),{rect:f$1,setRect:h}=st(),p=g=>{g.target&&(h(g,()=>u.current),s&&m(!0));},b=(g,x)=>{t?g.preventDefault():r(x.value);};return w.createElement("div",{role:"tablist",ref:u,onMouseLeave:()=>m(!1),...d},w.createElement(ft,{rect:f$1,visible:c,hoverHeightRatio:n,hoverWidthRatio:i$1}),e&&e.map(g=>w.createElement(vl,{role:"tab",key:g.value,onClick:x=>b(x,g),active:o===g.value,onMouseOver:p,disabled:t,...g},w.createElement(w.Fragment,null,g.icon&&g.icon),w.createElement(w.Fragment,null,i(g.title)?f(g.title):g.title))))})`
  position: relative;
  display: flex;
  flex-grow: 0;
  align-items: center;
  color: ${({theme:e})=>e.colors.accent.dark};
  font-weight: ${({theme:e})=>e.weight.medium};
  box-shadow: 0 0 0 1px ${({theme:e})=>e.colors.layout.dark}; // because border will add 2px to the hightlight rect
  border-radius: ${({theme:e})=>e.radius.square};
  padding: 4px;
  gap: 1px;
`,vl=X.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: ${({disabled:e})=>e?"default":"pointer"};
  color: ${({theme:e,active:t,disabled:o})=>o?e.colors.text.darker:t?e.colors.text.lightest:e.colors.text.light};
  user-select: none;
  padding: 6px ${({theme:e})=>e.gap.small};
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
  outline: 0;
  white-space: nowrap;
  border-radius: ${({theme:e})=>e.radius.square};
  background-color: ${({theme:e,active:t})=>t?e.colors.layout.dark:"transparent"};
  transition: all 0.2s;
  z-index: 1;

  svg {
    max-height: 1em;
    margin-right: ${({theme:e})=>e.gap.tiny};
  }

  &:hover {
    color: ${({theme:e,disabled:t})=>t?e.colors.text.darker:e.colors.text.lightest};
  }
`;xn.displayName="KitchnSwitch";var zP=l(xn);var yn=forwardRef(({placeholder:e,disabled:t,defaultValue:o,...r},n)=>w.createElement("textarea",{ref:n,"aria-disabled":t,placeholder:e,disabled:t,defaultValue:o,...r}));yn.displayName="Textarea";var Pn=X(yn)`
  position: relative;
  outline: none;
  transition: all 0.2s;
  user-select: none;
  resize: ${({resize:e="none"})=>e};
  border-radius: ${({theme:e})=>e.radius.square};
  padding: ${({theme:e})=>e.gap.small};
  width: ${({width:e})=>e?`${e}px`:"100%"};
  height: ${({height:e})=>e?`${e}px`:"auto"};
  min-height: 50px;
  cursor: ${({disabled:e})=>e?"not-allowed":"text"};
  background-color: ${({theme:e,disabled:t})=>t?e.colors.layout.darker:e.colors.layout.darkest};
  font-size: ${({theme:e})=>e.size.small};
  border: 1px solid
    ${({errored:e,disabled:t,theme:o})=>e?o.colors.accent.danger:t?o.colors.layout.darker:o.colors.layout.dark};
  color: ${({errored:e,theme:t})=>e?t.colors.accent.danger:t.colors.text.lightest};
  :placeholder {
    color: ${({theme:e})=>e.colors.text.light};
  }
  &:focus {
    border: 1px solid
      ${({theme:e,errored:t})=>t?e.colors.accent.danger:e.colors.layout.lighter};
  }
`;Pn.displayName="KitchnTextarea";var FP=l(Pn);var Tn=X(({actions:e,cancelHandle:t,...o})=>{let r=(n,i)=>{i&&i(n,t);};return w.createElement(y,{justify:"center",align:"flex-end",flex:"0",...o},w.createElement(y,{gap:"tiny"},e.map((n,i)=>w.createElement(ve,{key:i,onClick:s=>r(s,n.handler),size:"small",type:n.passive?"dark":"light"},f(n.name)))))})``;Tn.displayName="KitchnToastActions";var Ll=l(Tn),Cn=Ll;var $n=X(({toast:e,layout:t,...o})=>{let[r,n]=w.useState(null),[i,s]=w.useState(e.visible),d=typeof e.text!="string",{enter:u,leave:c}=w.useMemo(()=>or(t.placement),[t.placement]);return w.useEffect(()=>{e.visible&&!i&&s(!0);let f=setTimeout(()=>{n(e.visible?"entrance":"exit"),setTimeout(()=>{e.visible||n("done");},350),clearTimeout(f);},60);return ()=>{clearTimeout(f);}},[i,e.visible]),i?w.createElement(Il,{role:"alert","aria-live":"polite",key:e.id,animationState:r,enter:u,leave:c,layout:t,toast:e,...o},d?e.text:w.createElement(y,{row:!0,justify:"space-between",w:"100%"},w.createElement(C,{color:"inherit"},e.text),w.createElement(Cn,{actions:e.actions,cancelHandle:e.cancel}))):null})`
  width: ${({layout:e})=>e.width};
  max-width: ${({layout:e})=>e.maxWidth};
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({theme:e})=>e.colors.layout.lightest};
  border-radius: ${({theme:e})=>e.radius.square};
  overflow: hidden;
  transition: all 350ms cubic-bezier(0.1, 0.2, 0.1, 1);

  color: ${({theme:e,toast:t})=>{switch(t.type){case"danger":case"warning":case"info":case"success":case"secondary":return e.colors.accent.light;case"primary":default:return e.colors.text.lightest}}};

  background-color: ${({theme:e,toast:t})=>{switch(t.type){case"danger":return e.colors.accent.danger;case"warning":return e.colors.accent.warning;case"info":return e.colors.accent.info;case"success":return e.colors.accent.success;case"secondary":return e.colors.layout.light;case"primary":default:return e.colors.layout.darkest}}};
`,Il=X.div`
  opacity: ${({animationState:e})=>e==="entrance"?1:0};
  transform: ${({animationState:e,enter:t,leave:o})=>e===null?t:e==="entrance"?"translate(0, 0)":o};
  height: ${({animationState:e})=>e&&e!=="done"?"auto":0};
  padding: ${({layout:e,animationState:t})=>t&&t!=="done"?e.padding:0};
  margin: ${({layout:e,animationState:t})=>t&&t!=="done"?e.margin:0};
  border: ${({animationState:e})=>e&&e!=="done"?"1px":"0"}
    solid
    ${({theme:e,toast:t})=>{switch(t.type){case"danger":return h(e.colors.accent.danger,.5);case"warning":return h(e.colors.accent.warning,.5);case"info":return h(e.colors.accent.info,.5);case"success":return h(e.colors.accent.success,.5);case"secondary":return e.colors.layout.lighter;case"primary":default:return e.colors.layout.dark}}};
`;$n.displayName="KitchnToastItem";var Rl=w.memo($n),yo=l(Rl);var vn=X(({disabled:e,checked:t,onChange:o,...r})=>w.createElement("input",{"aria-checked":t,"aria-disabled":e,role:"switch",type:"checkbox",onChange:i=>{if(e)return i.preventDefault();o&&o(i);},checked:t,disabled:e,...r}))`
  appearance: none;
  box-sizing: border-box;
  width: ${({large:e})=>e?"40px":"28px"};
  height: ${({large:e})=>e?"20px":"14px"};
  border-radius: ${({theme:e})=>e.radius.round};
  background-color: ${({disabled:e,checked:t,theme:o})=>e?o.colors.layout.dark:t?o.colors.layout.lightest:o.colors.layout.dark};
  position: relative;
  transition: all 0.2s;
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
  border: 1px solid
    ${({disabled:e,checked:t,theme:o})=>e?o.colors.layout.dark:t?o.colors.layout.lightest:o.colors.layout.dark};

  &::before {
    content: "";
    position: absolute;
    width: ${({large:e})=>e?"18px":"12px"};
    height: ${({large:e})=>e?"18px":"12px"};
    background-color: ${({disabled:e,checked:t,theme:o})=>e?o.colors.layout.dark:t?o.colors.layout.lightest:o.colors.layout.dark};
    border-radius: ${({theme:e})=>e.radius.round};
    transition: all 0.2s;
    transform: translateX(
      ${({checked:e,large:t})=>e?"0":t?"20px":"14px"}
    );
  }

  &::after {
    content: "";
    position: absolute;
    width: ${({large:e})=>e?"18px":"12px"};
    height: ${({large:e})=>e?"18px":"12px"};
    background-color: ${({theme:e,disabled:t,checked:o})=>t?e.colors.layout.darker:o?e.colors.layout.darkest:e.colors.layout.light};
    border-radius: ${({theme:e})=>e.radius.round};
    transition: all 0.2s;
    transform: translateX(
      ${({checked:e,large:t})=>e?t?"20px":"14px":"0"}
    );
  }
`;vn.displayName="KitchnToggle";var aT=l(vn);var Bl=X,c0=Bl;

export { si as Avatar, vm as AvatarGroup, ai as AvatarImage, Im as Badge, bi as Button, fi as ButtonContent, hi as ButtonPrefix, gi as ButtonSuffix, Zh as Calendar, ag as Checkbox, Fa as CheckboxCheck, Na as CheckboxCheckContainer, Tr as CheckboxCheckmark, Ha as CheckboxContainer, Ka as CheckboxContent, Ba as CheckboxLabel, mg as Code, Ga as CodeContent, Wa as CodeHeader, _a as CodeTitle, es as Collapse, Pb as Combobox, rt as ComboboxContext, ns as ComboboxDropdown, is as ComboboxEmpty, ss as ComboboxItem, ls as ComboboxSearching, _e as Container, vl as Control, Qx as ControlledInput, us as Drawer, ds as DrawerContent, rs as Dropdown, Vb as Entity, tx as EntityField, xs as EntityFieldDescription, bs as EntityFieldTitle, Xi as Error, qi as ErrorAction, Yi as ErrorActionIcon, ji as ErrorContent, _i as ErrorIconContainer, Ui as ErrorLabel, Vi as ErrorText, Gi as ErrorTextContainer, Ss as Fieldset, Ax as Footer, zx as FooterColumn, Hx as FooterGroup, Ls as FooterGroupTitle, Bx as FooterLink, Ms as FooterNav, My as FragmentLink, Yn as GlobalStyle, Ps as Highlight, ys as HighlightContainer, Ki as Icon, _x as Image, gg as InlineCode, ca as Input, aa as InputClear, oa as InputContainer, sa as InputError, ra as InputField, la as InputLabel, na as InputPrefix, ia as InputSuffix, er as InputSuffixPart, vt as KeyCode, Se as KeyMod, sm as KitchnProvider, Po as KitchnProviderComponent, ma as Link, Os as ListItem, pe as Menu, jy as Modal, ri as NextThemeProviderWrapper, rP as Note, ml as NoteAction, pl as NoteContent, cl as NoteLabel, gy as OrderedList, sy as PasswordInput, cP as Progress, gl as ProgressCheckpoint, hl as ProgressCheckpointContainer, un as ProgressCheckpointTitle, ul as ProgressContainer, fl as ProgressState, yP as Select, Cl as SelectSelector, hs as Skeleton, vP as Spacer, di as Spinner, Oa as StyledCheckbox, Is as SubFooter, zP as Switch, Ht as Tab, Bt as Tabs, Ke as Text, FP as Textarea, yt as ThemeContext, Zt as ThemeProvider, Ll as ToastActions, Zn as ToastContainer, yo as ToastItem, Il as ToastItemAnimationContainer, Pt as ToastsContent, aT as Toggle, Pa as Tooltip, ba as TooltipContentContainer, Ve as TooltipContentInner, Cy as UnorderedList, ao as areaCss, eo as backgroundCss, oo as borderCss, Ye as convertThemeToCssVariables, ho as createElement, Yt as createTheme, Xt as createThemeVariables, c0 as default, Ne as defaultThemes, $e as defaultToastLayout, rr as defaultTooltipPosition, Rn as excludedProperties, zm as fadeIn, wo as fadeInDown, Hm as fadeOut, Eo as fadeOutUp, Bm as float, Jh as formatCaption, Ia as formatWeekdayName, Jt as generateThemes, Ao as getActiveModMap, No as getCtrlKeysByPlatform, Oo as getElementOffset, Ri as getEventRect, ir as getIconPosition, nr as getPosition, at as getRefRect, ct as getTooltipRect, or as getTranslateByPlacement, Wn as handleFont, j as handlePixelValue, to as handleRadius, v as handleValue, Je as isBrowser, ws as isFieldsetContainer, wt as isMac, $f as isRefTarget, _o as isUnplacedRect, Am as loading, so as mainCss, jt as mainTheme, ro as marginCss, no as paddingCss, io as positionCss, lo as resetCss, Nm as rotate, oi as shouldForwardProp, So as skBouncedelay, Fm as skeleton, Mo as slideInUp, Lo as slideOutDown, co as themeCss, we as useBreakpoint, id as useCheckbox, ot as useClickAnyWhere, zo as useClickAway, gd as useClipboard, nt as useCombobox, xe as useCurrentState, Bo as useDOMObserver, it as useKeyboard, We as useMediaQuery, Gd as useModal, O as usePortal, Ko as usePrevious, st as useRect, lt as useResize, uo as useSSR, Go as useTheme, au as useToasts, Xe as useToastsContext, Ee as useWarning, Iu as withBox, l as withDecorator, Bu as withScale };
//# sourceMappingURL=index.esm.js.map
//# sourceMappingURL=index.esm.js.map